/* eslint-disable react-hooks/rules-of-hooks */
import { useContext, useEffect, useMemo, useReducer, useState } from 'react';
import * as Yup from 'yup';
// 
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { Form, FormikProvider, useFormik } from 'formik';
//
import moment from 'moment';
// material
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  FormControlLabel,
  IconButton,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Radio,
  Select,
  Stack,
  TextField,
  Typography
} from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { makeStyles } from '@material-ui/styles';
import { DesktopDatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
// hooks
import useIsMountedRef from '../../../../hooks/useIsMountedRef';
//
import { getSectionByEventTypeApi } from "../../../../_apis_/authApi.js/analytic_api";
import { AnalyticContext } from '../../../../contexts/AnalyticContext';
import ScoreCardsContext from '../../../../contexts/ScoreCardsContext';
import { SettingsContext } from "../../../../contexts/SettingsContext";
import { handleStaffFilterData } from '../../../../redux/slices/AnalyticsSlices/StaffFilterSlice';
// import { handleFilterData } from '../../../../redux/slices/AnalyticsSlices/SupervisorFilterSlice';
// ----------------------------------------------------------------------

const useStyles = makeStyles(() => ({
  dropdownListStyle:
  {
    padding: 5
  },
  select: {
    backgroundColor: "#FFFFFF"
  },
  selectDisabled: {
    backgroundColor: "#E9ECEF"
  },
  textField: {
    backgroundColor: "#FFFFFF"
  },
  textFieldLock: {
    backgroundColor: "#E9ECEF"
  },
  selectLock: {
    backgroundColor: "#E9ECEF"
  }
}));

// ----------------------------------------------------------------------

export default function AnalyticsFilterDialog({ addUserButton, setAddMode, closeAddUserDialog }) {
  const [searchParams, setSearchParams] = useSearchParams();

  const dateRange = [
    {
      "id": 1,
      "dateRange": "Today"
    },
    {
      "id": 2,
      "dateRange": "Yesterday"
    },
    {
      "id": 3,
      "dateRange": "This Week"
    },
    {
      "id": 4,
      "dateRange": "Last Week"
    },
    {
      "id": 5,
      "dateRange": "This Month"
    },
    {
      "id": 6,
      "dateRange": "Last Month"
    },
    {
      "id": 7,
      "dateRange": "This Quarter"
    },
    {
      "id": 8,
      "dateRange": "Last Quarter"
    },
    {
      "id": 9,
      "dateRange": "This Year"
    },
    {
      "id": 10,
      "dateRange": "Last Year"
    },
    {
      "id": 11,
      "dateRange": "Custom Date Range"
    },
  ]

  const filterBy = [
    {
      "id": 1,
      "type": "Score Date"
    },
    {
      "id": 2,
      "type": "Event Date"
    },
    {
      "id": 3,
      "type": "Last Edit Date"
    }
  ]

  const formulaType = [
    {
      id: 10,
      type: 'True'
    },
    {
      id: 20,
      type: 'Potential'
    }
  ]

  const { getScoreLogGroups, reportsScoreLogGroups, getScoreLogScorecards,
    scorecardSection, getSectionDropdown, reportsScoreLogScorecards,
    getScoreLogEventType, reportsScoreLogEventType, getScoreLogEventSubType,
    reportsScoreLogEventSubType, getScoreLogTeams,
    reportsScoreLogTeams, getScoreLogSupervisor, reportsScoreLogSupervisor,
    getScoreLogEmployee, reportsScoreLogEmployee,
    getScoreLogEvaluator, reportsScoreLogEvaluator,
    questionsAnswerByStaff, getQuestionsAnswerByStaff,
    loadingState
  } = useContext(ScoreCardsContext);

  const { setIsLoadingTeams,
    dateType, selScDuration, dataTagByScoreCard,
    setSelectedAnaDateRange,
    setSelectedToDate, setSelectedFromDate,
    setSelectedFilterBy,
    setCountAgent,
    subModLabel,
    setselectedStaFilter, setSelectedGroupFilter,


    setSelectedStaffFilter,
    getDataTagsByScoreCard,
    dateTypeSecTrend, setSelectedStaffFromDate,
    setSelectedScoreCardSingle,
    setSelectedStaffFromWeek, setSelectedStaffToDate,
    selectedStaffToWeek, selectedStaffFromWeek,
    setSelectedStaffToWeek,
    setSelectedFilterByValue

  } = useContext(AnalyticContext);
  const { dataCreatedFrom } = useContext(SettingsContext);

  const [open, setOpen] = useState(false);

  const [advanceFilters, setAdvanceFilters] = useState();
  const [customFilters, setCustomFilters] = useState(false);
  const [circular, setCircular] = useState(false);

  const [isAnyOfTag, setIsAnyOfTag] = useState(true)
  const [isAllOfTag, setIsAllOfTag] = useState(false)
  const [fromWeekNo, setFromWeekNo] = useState([]);
  const [toWeekNo, setToWeekNo] = useState([]);

  const isMountedRef = useIsMountedRef();
  const loggedUserData = JSON.parse(window.localStorage.getItem('userData'));

  const newDispatch = useDispatch()
  const filterFieldsData = useSelector(state => state.staffFilterFields?.filterFieldsData)

  const initialState = {
    openGroupField: false,
    openSingleScorecardField: false,
    openMultiScorecardField: false,
    openEventTypeField: false,
    openEventSubTypeField: false,
    openTeamField: false,
    openSupervisorField: false,
    openStaffField: false,
    openSectionField: false,
    openQuestionField: false,
    openEvalField: false,

  }

  const reducerFunc = (state, action) => {
    switch (action.type) {
      case 'SET_VALUE':
        return { ...state, ...action.payload };
      case 'RESET_VALUE':
        return initialState;
      default:
        return state;
    }
  }
  const [state, dispatch] = useReducer(reducerFunc, initialState)

  // helper function to update state value--
  const updateState = (key, value) => {
    dispatch({ type: 'SET_VALUE', payload: { [key]: value } });
  };

  // helper function to reset the state

  const ReportSchema = Yup.object().shape({
    scoreCard: (subModLabel === 1.4 || subModLabel === 1.1 || subModLabel === 1.9) ? Yup.number().transform((value) => Number.isNaN(value) ? null : value).required('This Value is required').nullable() : '',
    scoreCardSingle: (subModLabel === 1.6 || subModLabel === 1.8 || subModLabel === 1.7 || subModLabel === '1.10' || subModLabel === 1.2 || subModLabel === 1.3 || subModLabel === 1.31) ? Yup.number().required('This Value is required').nullable() : '',
    staff: (subModLabel === 1.4 || subModLabel === 1.5 || subModLabel === 1.8 || subModLabel === 1.7 || subModLabel === 1.6) ? Yup.number().required('This Value is required').nullable() : Yup.string().nullable(),
    group: (subModLabel === 1.4 || subModLabel === 1.6 || subModLabel === 1.1 || subModLabel === 1.8 || subModLabel === 1.7 || subModLabel === '1.10' || subModLabel === 1.5 || subModLabel === 1.2 || subModLabel === 1.3 || subModLabel === 1.31 || subModLabel === 1.9) ? Yup.number().required('This Value is required').nullable() : Yup.string().nullable(),
  });
  const formik = useFormik({
    initialValues: {
      id: '',
      dateRange: '',
      filterByRange: '',
      fromDate: '',
      toDate: '',
      fromweekValue: '',
      toweekValue: '',
      filterBy: '',
      group: '',
      teams: '',
      scoreCard: [],
      scoreCardSingle: '',
      scoreCardSingle2: '',
      scoreCardName: [],
      eventType: '',
      eventTypeEventSubType: '',
      supervisor: '',
      staff: '',
      scoreCardCategory: '',
      evaluator: '',
      highlightValue: '',
      reference: '',
      section: '',
      question: '',
      formula: '',
      teamsId: searchParams.get('teams__id') || '',
      allOfTag: '',
      anyOfTag: '',
      dataTag: [],
      eventTypeEventType: '',
      eventSubTypeEventSubType: '',
      groupField: {},
      teamField: {},
      singleScorecardField: {},
      multiScorecardField: [],
      eventField: {},
      eventSubField: {},
      supervisorField: {},
      sectionField: {},
      questionField: {},
      evaluatorField: {}
    },
    validationSchema: ReportSchema,
    onSubmit: async (values, { setErrors, setSubmitting }) => {
      setCircular(true);
      try {

        const staffFilterObj =
        {
          "fromDate": moment(values.fromDate).format('YYYY-MM-DD'),
          "toDate": moment(values.toDate).format('YYYY-MM-DD'),
          'fromWeek': values?.fromWeek,
          'toWeek': values?.toWeek,
          "dateRange": values?.dateRange,
          "filterBy": values.filterBy,
          "group": values.group,
          "teams": values.teams,
          "scoreCard": values.scoreCard,
          // "scoreCard": (subModLabel === 1.3 || subModLabel === 1.31 || subModLabel === 5.11 || subModLabel === 5.12) ? values.scoreCardSingle : values.scoreCard,
          "scoreCardGroups": values?.group,
          "eventType": values.eventType,
          "eventTypeEventSubType": values.eventTypeEventSubType,
          "staff": values.staff,
          "scoreCardCategory": values.scoreCardCategory,
          "evaluator": values?.evaluator || "",
          "page": "1",
          "filterName": "",
          "highlightValue": values.highlightValue,
          "flag": dateTypeSecTrend,
          "formula": values.formula,
          "reference": values.reference,
          "section": values.section,
          "supervisor": values.supervisor,
          "question": values.question,
          "teamsId": values.teamsId,
          "filterByRange": values.filterByRange,
          "eventTypeEventType": values.eventTypeEventType,
          "eventSubTypeEventSubType": values.eventSubTypeEventSubType,
          "groupField": values.groupField,
          "teamField": values.teamField,
          "singleScorecardField": values.singleScorecardField,
          'eventField': values?.eventField,
          'eventSubField': values?.eventSubField,
          "multiScorecardField": values?.multiScorecardField,
          "supervisorField": values?.supervisorField,
          "staffFieldWithAll": values.staffFieldWithAll,
          "staffField": values.staffField,
          "sectionField": values.sectionField,
          "questionField": values.questionField,
          "evaluatorField": values.evaluatorField,
          "scoreCardSingle": values.scoreCardSingle,
          "scoreCardSingle2": values.scoreCardSingle,
          'subModule': subModLabel,
        }

        localStorage.setItem('fromWeek', JSON.stringify(selectedStaffFromWeek))
        localStorage.setItem('toWeek', JSON.stringify(selectedStaffToWeek))

        if (subModLabel === 1.1) {

          handleClose();

          const arr = values?.scoreCard?.sort((a, b) => b - a)
          // redux thunk call to set the data in the redux---
          const newFilter = { ...staffFilterObj, scoreCardSingle: arr[0], scoreCardSingle2: arr[0] }
          newDispatch(handleStaffFilterData(newFilter))

        } else if (subModLabel === 1.2) {

          // redux thunk dispatch to store the filter 
          const newFilter = { ...staffFilterObj, scoreCardSingle: values.scoreCardSingle, scoreCardSingle2: values.scoreCardSingle }
          newDispatch(handleStaffFilterData(newFilter))
          handleClose();
        }
        else if (subModLabel === 1.3) {
          // redux thunk dispatch to store the filter 
          const newFilter = { ...staffFilterObj, scoreCardSingle: values.scoreCardSingle, scoreCardSingle2: values.scoreCardSingle }
          newDispatch(handleStaffFilterData(newFilter))
          handleClose();
        }
        else if (subModLabel === 1.31) {
          // redux thunk call-----
          const newFilter = { ...staffFilterObj, scoreCardSingle: values.scoreCardSingle, scoreCardSingle2: values.scoreCardSingle }
          newDispatch(handleStaffFilterData(newFilter))
          handleClose();
        }
        else if (subModLabel === 1.4) {
          const sortedScoreCards = [...(values?.scoreCard || [])].sort((a, b) => b - a);
          const updatedFilters = {
            ...staffFilterObj,
            scoreCardSingle: sortedScoreCards[0],
            dataTags: values?.dataTag || '',
            dataTagsOperator: values?.anyOfTag || values?.allOfTag || '10',
          };

          // redux thunk call----
          newDispatch(handleStaffFilterData(updatedFilters))
          setCircular(false)
          handleClose();
        }
        if (subModLabel === 1.5) {
          // setIsSectionLoading(true);
          // setSectionTrndData([]);

          // redux thunk call-----
          const newFilter = { ...staffFilterObj, scoreCardSingle: values.scoreCardSingle, dateTypeValue: dateType }
          newDispatch(handleStaffFilterData(newFilter))

          handleClose();
          setselectedStaFilter([values.scoreCardSingle])
          setSelectedStaffFilter(values?.staff)

        }

        if (subModLabel === 1.6) {


          // redux thunk call-----
          const newFilter = {
            ...staffFilterObj,
            scoreCardSingle: values.scoreCardSingle,
            scoreCardSingle2: values.scoreCardSingle,
            flag: selScDuration,
            dataTags: values?.dataTag || '',
            dataTagsOperator: values.anyOfTag || values.allOfTag
          }
          newDispatch(handleStaffFilterData(newFilter))

          handleClose();

          if (useIsMountedRef.current) {
            setSubmitting(false);
            setOpen(false);
          }
        }

        if (subModLabel === 1.7) {

          // redux thunk call-----
          const newFilter = {
            ...staffFilterObj,
            scoreCardSingle: values.scoreCardSingle,
            scoreCardSingle2: values.scoreCardSingle,

          }
          newDispatch(handleStaffFilterData(newFilter))

          handleClose();

        }

        if (subModLabel === 1.8) {
          const filterObj =
          {
            "fromDate": moment(values.fromDate).format('YYYY-MM-DD'),
            "toDate": moment(values.toDate).format('YYYY-MM-DD'),
            "filterBy": values.filterBy,
            "group": values.group,
            "teams": values.teams,
            "scoreCard": values.scoreCardSingle,
            "eventType": values.eventType,
            "eventTypeEventSubType": values.eventTypeEventSubType,
            "staff": values.staff,
            "page": "1",
            "highlightValue": values.highlightValue,
            "formula": values.formula,
            "section": values.section,
          }

          // redux thunk call-----
          const newFilter = {
            ...staffFilterObj,
            scoreCardSingle: values.scoreCardSingle
            // scoreCard: [values.scoreCardSingle],
          }
          newDispatch(handleStaffFilterData(newFilter))
          handleClose();
        }


        if (subModLabel === 1.9) {

          // redux thunk call-----
          const newFilter = {
            ...staffFilterObj,
            scoreCardSingle: values.scoreCardSingle,
            scoreCardSingle2: values.scoreCardSingle,
            dataTag: values.dataTag || '',
            dataTagsOperator: values.anyOfTag || values.allOfTag || '10'
          }
          newDispatch(handleStaffFilterData(newFilter))

        }

        if (subModLabel === '1.10') {

          // redux thunk call-----
          const newFilter = {
            ...staffFilterObj,
            scoreCardSingle: values.scoreCardSingle,
            scoreCardSingle2: values.scoreCardSingle
          }
          newDispatch(handleStaffFilterData(newFilter))

          handleClose();

          if (useIsMountedRef.current) {
            setSubmitting(false);
            setOpen(false)
          }
        }

        if (subModLabel === 1.11) {

          // redux thunk call-----
          const newFilter = {
            ...staffFilterObj,
            // scoreCard: [values.scoreCardSingle],
            scoreCardSingle: values.scoreCardSingle,
            scoreCardSingle2: values.scoreCardSingle
          }
          newDispatch(handleStaffFilterData(newFilter))

          handleClose();

          if (useIsMountedRef.current) {
            setSubmitting(false);
            setOpen(false)
          }
        }
        setCircular(false)
        handleClose();

      } catch (error) {
        setIsLoadingTeams(false);
        if (isMountedRef.current) {
          setSubmitting(false);
          setErrors({ afterSubmit: error.message });
        }

        if (subModLabel === 1.11) {
          setCountAgent(0);
        }
      }
    },
    enableReinitialze: true,
  });

  const { errors, touched, values, setFieldValue, handleSubmit, isSubmitting, getFieldProps } = formik;
  useEffect(() => {

    if (open) {
      if (filterFieldsData?.dateRange) {
        if (subModLabel === 1.2) {
          if (filterFieldsData?.dateRange === 'Last Year' ||
            filterFieldsData?.dateRange === 'This Year') {
            setFieldValue("dateRange", 'This Month');
            setFieldValue("fromDate", moment().startOf('month').format('YYYY-MM-DD'));
            setFieldValue("toDate", moment().endOf('month').format('YYYY-MM-DD'));
            setSelectedFromDate(moment().startOf('month').format('YYYY-MM-DD'))
            setSelectedToDate(moment().endOf('month').format('YYYY-MM-DD'))
            setSelectedAnaDateRange('This Month');


          } else if (filterFieldsData?.dateRange === 'Custom Date Range') {
            setFieldValue("dateRange", filterFieldsData?.dateRange);
            const fromDate = moment(filterFieldsData?.fromDate);
            const toDate = moment(filterFieldsData?.toDate);
            const diffMonths = toDate.diff(fromDate, 'months', true); // Calculate difference in months

            if (diffMonths > 3) {
              // If difference is greater than 3 months, update toDate
              const newToDate = fromDate.add(3, 'months').format('YYYY-MM-DD');
              setFieldValue("fromDate", filterFieldsData?.fromDate); // Keep fromDate same
              setFieldValue("toDate", newToDate); // Update toDate to be 3 months after fromDate
            } else {
              // If difference is 3 months or less, keep values unchanged
              setFieldValue("fromDate", filterFieldsData?.fromDate);
              setFieldValue("toDate", filterFieldsData?.toDate);
            }
          } else {
            setFieldValue("dateRange", filterFieldsData?.dateRange);
            setFieldValue("fromDate", filterFieldsData?.fromDate);
            setFieldValue("toDate", filterFieldsData?.toDate);
          }
        } else {
          setFieldValue("dateRange", filterFieldsData?.dateRange);
          setFieldValue("fromDate", filterFieldsData?.fromDate);
          setFieldValue("toDate", filterFieldsData?.toDate);
        }


      } else {
        setFieldValue("dateRange", 'This Month');
        setFieldValue("fromDate", moment().startOf('month').format('YYYY-MM-DD'));
        setFieldValue("toDate", moment().endOf('month').format('YYYY-MM-DD'));
        setSelectedFromDate(moment().startOf('month').format('YYYY-MM-DD'))
        setSelectedToDate(moment().endOf('month').format('YYYY-MM-DD'))
        setSelectedAnaDateRange('This Month');
      }

      if (filterFieldsData?.dateRange === 'Custom Date Range') {
        if (subModLabel === 1.2) {
          setFieldValue("dateRange", 'Custom Date Range');

          setCustomFilters(true);
          const fromDate = moment(filterFieldsData?.fromDate);
          const toDate = moment(filterFieldsData?.toDate);
          const diffMonths = toDate.diff(fromDate, 'months', true); // Calculate difference in months

          if (diffMonths > 3) {
            // If difference is greater than 3 months, update toDate
            const newToDate = fromDate.clone().add(3, 'months'); // Clone to prevent modifying fromDate
            setFieldValue("fromDate", filterFieldsData?.dateRange); // Keep fromDate same
            setFieldValue("toDate", newToDate.format('YYYY-MM-DD')); // Update toDate to be 3 months after fromDate

            // Set weeks according to updated dates
            formik.setFieldValue("fromWeek", fromDate.isoWeek());
            formik.setFieldValue("toWeek", newToDate.isoWeek());
          } else {
            // If difference is 3 months or less, keep values unchanged
            setFieldValue("fromDate", filterFieldsData?.fromDate);
            setFieldValue("toDate", filterFieldsData?.toDate);

            // Set weeks according to existing dates
            formik.setFieldValue("fromWeek", fromDate.isoWeek());
            formik.setFieldValue("toWeek", toDate.isoWeek());
          }



        } else {
          setCustomFilters(true);
          formik.setFieldValue("fromDate", filterFieldsData?.fromDate);
          formik.setFieldValue("toDate", filterFieldsData?.toDate);
          formik.setFieldValue("fromWeek", selectedStaffFromWeek);
          formik.setFieldValue("toWeek", selectedStaffToWeek);
        }

      }
      if (open) {
        const arrFromWeek = [];
        const arrToWeek = [];
        if (formik.values.fromWeek > moment().week()) {
          for (let i = 1; i <= formik.values.fromWeek; i += 1) {
            arrFromWeek.push(i);
            // i += 1;
          }
          setFromWeekNo(arrFromWeek);
        } else {
          for (let i = 1; i <= moment().week(); i += 1) {
            arrFromWeek.push(i);
            // i += 1;
          }
          setFromWeekNo(arrFromWeek);
        }

        if (formik.values.toWeek > moment().week()) {
          for (let i = 1; i <= formik.values.toWeek; i += 1) {
            arrToWeek.push(i);
            // i += 1;
          }
          setToWeekNo(arrToWeek);
        } else {
          for (let i = 1; i <= moment().week(); i += 1) {
            arrToWeek.push(i);
            //  i += 1;
          }
          setToWeekNo(arrToWeek);
        }
      }

      if (filterFieldsData?.filterByRange) {
        setFieldValue("filterByRange", filterFieldsData?.filterByRange);
        setFieldValue("filterBy", filterFieldsData?.filterBy);
        switch (filterFieldsData?.filterByRange) {
          case 'Score Date':
            setFieldValue("filterBy", 'created_at');
            break;
          case 'Event Date':
            setFieldValue("filterBy", 'event_date');
            break;
          case 'Last Edit Date':
            setFieldValue("filterBy", 'updated_at');
            break;
          default:
            setFieldValue("filterBy", 'created_at');
            break;
        }

      } else {
        setFieldValue("filterByRange", 'Score Date');
        setFieldValue("filterBy", 'created_at');
      }

      if (filterFieldsData?.group) {
        setFieldValue("group", (filterFieldsData?.group));
      } else {
        setFieldValue("group", '');
      }

      if (filterFieldsData?.groupField) {
        setFieldValue("groupField", (filterFieldsData?.groupField));
      } else {
        setFieldValue("groupField", {});
      }

      if (filterFieldsData?.teams) {
        setFieldValue("teams", filterFieldsData?.teams);
      }
      else {
        setFieldValue("teams", '');
      }

      if (filterFieldsData?.teamField) {
        setFieldValue("teamField", filterFieldsData?.teamField);
      } else {
        setFieldValue("teamField", { id: '', name: "All" });
      }
      if (filterFieldsData?.supervisor) {
        setFieldValue("supervisor", filterFieldsData?.supervisor);
      } else {
        setFieldValue("supervisor", '');
      }
      if (filterFieldsData?.supervisorField) {
        setFieldValue("supervisorField", filterFieldsData?.supervisorField);
      } else {
        setFieldValue("supervisorField", { supervisorUserFirstName: 'All', supervisorUserLastName: '', supervisor: '' });
      }

      if (filterFieldsData?.staff) {
        setFieldValue("staff", filterFieldsData?.staff);
      } else {
        setFieldValue("staff", '');
      }

      // staff field which have 'All' dopdown
      if (filterFieldsData?.staffFieldWithAll) {
        setFieldValue("staffFieldWithAll", filterFieldsData?.staffFieldWithAll);
      } else {
        setFieldValue("staffFieldWithAll", {
          staffUserFirstName: 'All',
          staffUserLastName: '',
          supervisor: ''
        });
      }

      if (filterFieldsData?.staffField) {
        setFieldValue("staffField", filterFieldsData?.staffField);
      } else {
        setFieldValue("staffField", '');
      }

      if (filterFieldsData?.scoreCard !== undefined) {
        setFieldValue("scoreCard", filterFieldsData?.scoreCard);
        const filterScoreCardObj = {
          "fromDate": moment(filterFieldsData?.fromDate).format('YYYY-MM-DD'),
          "toDate": moment(filterFieldsData?.toDate).format('YYYY-MM-DD'),
          "filterBy": filterFieldsData?.filterBy || 'created_at',
          "scoreCard": filterFieldsData?.scoreCard ?? '',
        }
        getDataTagsByScoreCard(filterScoreCardObj);
      } else {
        setFieldValue("scoreCard", '');
      }
      if (filterFieldsData?.multiScorecardField) {
        setFieldValue("multiScorecardField", filterFieldsData?.multiScorecardField);
        setFieldValue("singleScorecardField", filterFieldsData?.multiScorecardField[0])

      } else {
        setFieldValue("multiScorecardField", []);
      }

      // (subModLabel === 1.5 || subModLabel === 1.11 || subModLabel === 1.8 || subModLabel === 1.7 ||
      // subModLabel === 1.6 || subModLabel === 1.2 || subModLabel === 1.3 ||
      // subModLabel === 1.31 || subModLabel === '1.10') && filterFieldsData?.scoreCardSingle

      if (filterFieldsData?.scoreCardSingle || filterFieldsData?.scoreCard?.length !== 0) {
        if (filterFieldsData?.singleScorecardField) {
          setFieldValue("scoreCardSingle", filterFieldsData?.scoreCardSingle);
        } else if (filterFieldsData?.scoreCard) {
          setFieldValue("scoreCardSingle", filterFieldsData?.scoreCard[0]);
        }

        // const filterScoreCardObj = {
        //   "fromDate": moment(values?.fromDate).format('YYYY-MM-DD'),
        //   "toDate": moment(values?.toDate).format('YYYY-MM-DD'),
        //   "filterBy": selectedFilterByValue || 'created_at',
        //   "scoreCard": filterFieldsData?.scoreCardSingle ?? '',
        // }
        // getDataTagsByScoreCard(filterScoreCardObj);
      } else {
        setFieldValue("scoreCardSingle", '');
      }
      if ((filterFieldsData?.singleScorecardField || filterFieldsData?.multiScorecardField?.length !== 0)) {
        if (filterFieldsData?.singleScorecardField) {

          setFieldValue("singleScorecardField", filterFieldsData?.singleScorecardField)
        } else if (filterFieldsData?.multiScorecardField) {
          setFieldValue("singleScorecardField", filterFieldsData?.multiScorecardField[0])

        }
      } else {
        setFieldValue("singleScorecardField", {});
      }

      if (filterFieldsData?.dataTag) {
        setFieldValue("dataTag", filterFieldsData?.dataTag);
      }
      if (filterFieldsData?.dataTagsOperator === '20') {
        setFieldValue('allOfTag', '20')
        setIsAllOfTag(true)
        setFieldValue('anyOfTag', '')
        setIsAnyOfTag(false)

      } else if (filterFieldsData?.dataTagsOperator === '10') {
        setFieldValue('anyOfTag', '10')
        setIsAnyOfTag(true)
        setIsAllOfTag(false)
        setFieldValue('allOfTag', '')

      } else {
        setFieldValue('anyOfTag', '10')
        setIsAnyOfTag(true)
        setIsAllOfTag(false)
      }

      if (filterFieldsData?.eventType) {
        setFieldValue("eventType", filterFieldsData?.eventType);
      } else {
        setFieldValue("eventType", '');
      }

      if (filterFieldsData?.eventField) {
        setFieldValue("eventField", filterFieldsData?.eventField);
      } else {
        setFieldValue("eventField", {
          eventType: '',
          eventTypeEventType: "All",
          scoreCard: ''
        })
      }

      if (filterFieldsData?.eventTypeEventSubType) {
        setFieldValue("eventTypeEventSubType", filterFieldsData?.eventTypeEventSubType);
      } else {
        setFieldValue("eventTypeEventSubType", '');
      }

      if (filterFieldsData?.eventSubField) {
        setFieldValue("eventSubField", filterFieldsData?.eventSubField);
      } else {
        setFieldValue("eventSubField", {
          eventSubType: '',
          subType: "All",
          scorecard: ''
        })
      }
      // for 1.8 event filter 
      // if (filterFieldsData?.eventType) {
      //   setFieldValue("eventType", filterFieldsData?.eventType);
      // }
      // else {
      //   setFieldValue("eventType", '');
      // }

      // if (filterFieldsData?.eventTypeEventSubType) {
      //   setFieldValue("eventTypeEventSubType", filterFieldsData?.eventTypeEventSubType);
      // }
      // else {
      //   setFieldValue("eventTypeEventSubType", '');
      // }
      // 1.8 module end

      // set value for section field
      if (filterFieldsData?.section) {
        setFieldValue('section', filterFieldsData?.section)
      } else {
        setFieldValue('section', '')

      }

      if (filterFieldsData?.sectionField) {
        setFieldValue('sectionField', filterFieldsData?.sectionField)
      } else {
        setFieldValue('sectionField', {
          id: '',
          name: 'All',
          scoreCard: '',
          type: ''
        })

      }

      // set value for question field
      if (filterFieldsData?.question) {
        setFieldValue('question', filterFieldsData?.question)
      } else {
        setFieldValue('question', '')
      }

      if (filterFieldsData?.questionField) {
        setFieldValue('questionField', filterFieldsData?.questionField)
      } else {
        setFieldValue('questionField', {
          id: '',
          question: 'All',
        })
      }

      if (searchParams.get('formula')) {
        setFieldValue('formula', searchParams.get('formula'))
      } else {
        setFieldValue('formula', '')
      }

      if (filterFieldsData?.highlightValue) {
        setFieldValue("highlightValue", filterFieldsData?.highlightValue)
      } else {
        setFieldValue("highlightValue", "");
      }
      setFieldValue("scoreCardCategory", '');

      if (filterFieldsData?.evaluator) {
        setFieldValue("evaluator", filterFieldsData?.evaluator);
      } else {
        setFieldValue("evaluator", '');
      }

      if (filterFieldsData?.evaluatorField) {
        setFieldValue("evaluatorField", filterFieldsData?.evaluatorField);
      } else {
        setFieldValue("evaluatorField", {
          evaluator: '',
          evaluatorFirstName: 'All',
          evaluatorLastName: ''
        });
      }
    }
  }, [open]);

  useEffect(() => {
    if (open) {
      const arrFromWeek = [];
      const arrToWeek = [];

      if (formik.values.fromWeek > moment().week()) {
        for (let i = 1; i <= formik.values.fromWeek; i += 1) {
          arrFromWeek.push(i);
          // i += 1;
        }
        setFromWeekNo(arrFromWeek);
      } else {
        for (let i = 1; i <= moment().week(); i += 1) {
          arrFromWeek.push(i);
          // i += 1;
        }
        setFromWeekNo(arrFromWeek);
      }

      if (formik.values.toWeek > moment().week()) {
        for (let i = 1; i <= formik.values.toWeek; i += 1) {
          arrToWeek.push(i);
          // i += 1;
        }
        setToWeekNo(arrToWeek);
      } else {
        for (let i = 1; i <= moment().week(); i += 1) {
          arrToWeek.push(i);
          //  i += 1;
        }
        setToWeekNo(arrToWeek);
      }
    }

  }, [formik?.values]);


  // Open user dialog modal
  const handleClickOpen = () => {
    setOpen(true);
  };

  // Close user dialog modal
  const handleClose = (event, reason) => {
    if (reason !== 'backdropClick') {

      setOpen(false)

      if (!setAddMode) {
        closeAddUserDialog(false);
      }
    }
  };

  const handleDateRangeChange = (event) => {

    // Resetting remaining fields
    setFieldValue("group", '');
    setFieldValue("teams", '');
    setFieldValue("scoreCard", []);
    setFieldValue("scoreCardSingle", "");
    setFieldValue("scoreCardSingle2", "");
    setFieldValue("eventType", '');
    setFieldValue("eventTypeEventSubType", '');
    setFieldValue("staff", '');
    setFieldValue("scoreCardCategory", '');
    setFieldValue("evaluator", '');
    setFieldValue("supervisor", '');
    setFieldValue("highlightValue", '');
    setFieldValue("section", '');
    setFieldValue("question", '');
    setFieldValue("evaluator", '');
    setFieldValue("dataTag", []);
    setFieldValue("dataTagsOperator", '10');
    setFieldValue("higlightValue", '');

    setSelectedGroupFilter('')
    setSelectedScoreCardSingle('')
    setselectedStaFilter('')

    // redux state fields
    setFieldValue('groupField', {});
    setFieldValue('teamField', {
      id: '', name: 'All'
    });
    setFieldValue('multiScorecardField', []);
    setFieldValue('singleScorecardField', {});
    setFieldValue("eventField", {
      eventType: '',
      eventTypeEventType: "All",
      scoreCard: ''
    })
    setFieldValue('eventSubField', {
      eventSubType: '',
      subType: 'All',
      scorecard: ''
    })
    setFieldValue("supervisorField", {
      supervisorUserFirstName: 'All',
      supervisorUserLastName: '',
      supervisor: ''
    });
    setFieldValue("staffFieldWithAll", {
      staffUserFirstName: 'All',
      staffUserLastName: '',
      supervisor: ''
    });
    const dateRange = event.target.value;
    setFieldValue("dateRange", dateRange);

    switch (dateRange) {

      case 'Today':
        setCustomFilters(false);
        setFieldValue("fromDate", moment().format('YYYY-MM-DD'));
        setFieldValue("toDate", moment().format('YYYY-MM-DD'));
        setSelectedFromDate(moment().format('YYYY-MM-DD'))
        setSelectedToDate(moment().format('YYYY-MM-DD'))
        setSelectedAnaDateRange('Today');
        break;
      case 'Yesterday':
        setCustomFilters(false);
        setFieldValue("fromDate", moment().subtract(1, 'days').format('YYYY-MM-DD'));
        setFieldValue("toDate", moment().subtract(1, 'days').format('YYYY-MM-DD'));
        setSelectedFromDate(moment().subtract(1, 'days').format('YYYY-MM-DD'))
        setSelectedToDate(moment().subtract(1, 'days').format('YYYY-MM-DD'))
        setSelectedAnaDateRange('Yesterday');
        break;
      case 'This Week':
        setCustomFilters(false);
        setFieldValue("fromDate", moment().startOf('week').format('YYYY-MM-DD'));
        setFieldValue("toDate", moment().endOf('week').format('YYYY-MM-DD'));
        setSelectedFromDate(moment().startOf('week').format('YYYY-MM-DD'))
        setSelectedToDate(moment().endOf('week').format('YYYY-MM-DD'))
        setSelectedAnaDateRange('This Week');
        break;
      case 'Last Week':
        setCustomFilters(false);
        setFieldValue("fromDate", moment().subtract(1, 'weeks').startOf('week').format('YYYY-MM-DD'));
        setFieldValue("toDate", moment().subtract(1, 'weeks').endOf('week').format('YYYY-MM-DD'));
        setSelectedFromDate(moment().subtract(1, 'weeks').startOf('week').format('YYYY-MM-DD'))
        setSelectedToDate(moment().subtract(1, 'weeks').endOf('week').format('YYYY-MM-DD'))
        setSelectedAnaDateRange('Last Week');
        break;
      case 'This Month':
        setCustomFilters(false);
        setFieldValue("fromDate", moment().startOf('month').format('YYYY-MM-DD'));
        setFieldValue("toDate", moment().endOf('month').format('YYYY-MM-DD'));
        setSelectedFromDate(moment().startOf('month').format('YYYY-MM-DD'))
        setSelectedToDate(moment().endOf('month').format('YYYY-MM-DD'))
        setSelectedAnaDateRange('This Month');
        break;
      case 'Last Month':
        setCustomFilters(false);
        setFieldValue("fromDate", moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD'));
        setFieldValue("toDate", moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD'));
        setSelectedFromDate(moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD'))
        setSelectedToDate(moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD'))
        setSelectedAnaDateRange('Last Month');
        break;
      case 'This Quarter':
        setCustomFilters(false);
        setFieldValue("fromDate", moment().quarter(moment().quarter()).startOf('quarter').format('YYYY-MM-DD'));
        setFieldValue("toDate", moment().quarter(moment().quarter()).endOf('quarter').format('YYYY-MM-DD'));
        setSelectedFromDate(moment().quarter(moment().quarter()).startOf('quarter').format('YYYY-MM-DD'))
        setSelectedToDate(moment().quarter(moment().quarter()).endOf('quarter').format('YYYY-MM-DD'))
        setSelectedAnaDateRange('This Quarter');
        break;
      case 'Last Quarter':
        setCustomFilters(false);
        setFieldValue("fromDate", moment().subtract(1, 'quarter').startOf('quarter').format('YYYY-MM-DD'));
        setFieldValue("toDate", moment().subtract(1, 'quarter').endOf('quarter').endOf('month').format('YYYY-MM-DD'));
        setSelectedFromDate(moment().subtract(1, 'quarter').startOf('quarter').format('YYYY-MM-DD'))
        setSelectedToDate(moment().subtract(1, 'quarter').endOf('quarter').endOf('month').format('YYYY-MM-DD'))
        setSelectedAnaDateRange('Last Quarter');
        break;
      case 'This Year':
        setCustomFilters(false);
        setFieldValue("fromDate", moment().startOf('year').format('YYYY-MM-DD'));
        setFieldValue("toDate", moment().endOf('year').format('YYYY-MM-DD'));
        setSelectedFromDate(moment().startOf('year').format('YYYY-MM-DD'))
        setSelectedToDate(moment().endOf('year').format('YYYY-MM-DD'))
        setSelectedAnaDateRange('This Year');
        break;
      case 'Last Year':
        setCustomFilters(false);
        setFieldValue("fromDate", moment().subtract(1, 'year').startOf('year').format('YYYY-MM-DD'));
        setFieldValue("toDate", moment().subtract(1, 'year').endOf('year').format('YYYY-MM-DD'));
        setSelectedFromDate(moment().subtract(1, 'year').startOf('year').format('YYYY-MM-DD'))
        setSelectedToDate(moment().subtract(1, 'year').endOf('year').format('YYYY-MM-DD'))
        setSelectedAnaDateRange('Last Year');
        break;
      case 'Custom Date Range':
        setCustomFilters(true);
        setFieldValue("fromDate", moment());
        setFieldValue("toDate", moment());
        setSelectedFromDate(moment());
        setSelectedToDate(moment());

        if (moment().format('MM-DD') === '01-01') {
          setFieldValue("fromWeek", 1)
          setSelectedStaffFromWeek(1);
        }
        else {
          setFieldValue("fromWeek", moment().year(moment().format('YYYY')).week());
          setSelectedStaffFromWeek(moment().year(moment().format('YYYY')).week());
        }
        if (moment().format('MM-DD') === '01-01') {
          setFieldValue("toWeek", 1)
          setSelectedStaffToWeek(1)
        }
        else {
          setFieldValue("toWeek", moment().year(moment().format('YYYY')).week());
          setSelectedStaffToWeek(moment().year(moment().format('YYYY')).week());
        }
        setSelectedAnaDateRange('Custom Date Range');
        break;
      default:
        setFieldValue("fromDate", moment().format('YYYY-MM-DD'));
        setFieldValue("toDate", moment().format('YYYY-MM-DD'));
        break;
    }

  };
  const handleFromDate = (newValue) => {
    // Clear values while changing the from date
    setFieldValue("group", '');
    setSelectedGroupFilter('');
    setSelectedScoreCardSingle('');
    setselectedStaFilter('');
    setFieldValue('scoreCardSingle', '');
    setFieldValue("scoreCard", []);
    setFieldValue('groupField', {});
    setFieldValue('teamField', {
      id: '', name: 'All'
    });
    setFieldValue('multiScorecardField', []);
    setFieldValue('singleScorecardField', {});
    setFieldValue("eventField", {
      eventType: '',
      eventTypeEventType: "All",
      scoreCard: ''
    })
    setFieldValue('eventSubField', {
      eventSubType: '',
      subType: 'All',
      scorecard: ''
    })
    setFieldValue("supervisorField", {
      supervisorUserFirstName: 'All',
      supervisorUserLastName: '',
      supervisor: ''
    });
    setFieldValue("staffFieldWithAll", {
      staffUserFirstName: 'All',
      staffUserLastName: '',
      supervisor: ''
    });

    const today = moment().format('YYYY-MM-DD');
    const formattedNewValue = moment(newValue).format('YYYY-MM-DD');

    // Set fromDate values
    setFieldValue("fromDate", formattedNewValue);
    setSelectedStaffFromDate(formattedNewValue);
    setSelectedFromDate(formattedNewValue);

    // Handle weeks for fromDate
    if (moment(formattedNewValue).format('MM-DD') === '01-01') {
      formik.setFieldValue("fromWeek", 1);
      setSelectedStaffFromWeek(1);
    } else {
      formik.setFieldValue("fromWeek", moment(formattedNewValue).isoWeek());
      setSelectedStaffFromWeek(moment(formattedNewValue).isoWeek());
    }

    // If subModLabel is 1.2 and fromDate is changed, adjust toDate
    if (subModLabel === 1.2) {
      if (moment(formattedNewValue).isBefore(formik.values.fromDate)) {
        let newToDate = moment(formattedNewValue).add(3, 'months');
        if (newToDate.isAfter(today)) {
          newToDate = moment(today); // ensure no future date
        }
        newToDate = newToDate.format('YYYY-MM-DD');

        setFieldValue("toDate", newToDate);
        setSelectedToDate(newToDate);
        setSelectedStaffToDate(newToDate);

        formik.setFieldValue("toWeek", moment(newToDate).isoWeek());
        setSelectedStaffToWeek(moment(newToDate).isoWeek());
      }

      // Ensure toDate is not in the future and is after fromDate
      if (moment(formattedNewValue).isAfter(formik.values.toDate) || moment(formik.values.toDate).isAfter(today)) {
        let adjustedToDate = moment(formattedNewValue).format('YYYY-MM-DD');

        if (moment(adjustedToDate).isAfter(today)) {
          adjustedToDate = today;
        }

        formik.setFieldValue("toDate", adjustedToDate);
        setSelectedStaffToDate(adjustedToDate);
        setSelectedToDate(adjustedToDate);

        if (moment(adjustedToDate).format('MM-DD') === '01-01') {
          formik.setFieldValue("toWeek", 1);
          setSelectedStaffToWeek(1);
        } else {
          formik.setFieldValue("toWeek", moment(adjustedToDate).isoWeek());
          setSelectedStaffToWeek(moment(adjustedToDate).isoWeek());
        }
      }
    }
  }
  const handleToDate = (newValue) => {
    // Clear values while changing the toDate
    setFieldValue("group", '');
    setSelectedGroupFilter('');
    setSelectedScoreCardSingle('');
    setselectedStaFilter('');
    setFieldValue('scoreCardSingle', '');
    setFieldValue("scoreCard", []);
    setFieldValue('groupField', {});
    setFieldValue('teamField', {
      id: '', name: 'All'
    });
    setFieldValue('multiScorecardField', []);
    setFieldValue('singleScorecardField', {});
    setFieldValue("eventField", {
      eventType: '',
      eventTypeEventType: "All",
      scoreCard: ''
    })
    setFieldValue('eventSubField', {
      eventSubType: '',
      subType: 'All',
      scorecard: ''
    })
    setFieldValue("supervisorField", {
      supervisorUserFirstName: 'All',
      supervisorUserLastName: '',
      supervisor: ''
    });
    setFieldValue("staffFieldWithAll", {
      staffUserFirstName: 'All',
      staffUserLastName: '',
      supervisor: ''
    });

    const formattedNewValue = moment(newValue).format('YYYY-MM-DD');
    const fromDateValue = formik.values.fromDate ? moment(formik.values.fromDate).format('YYYY-MM-DD') : null;

    // Update toDate values
    setFieldValue("toDate", formattedNewValue);
    setSelectedToDate(formattedNewValue);
    setSelectedStaffToDate(formattedNewValue);

    // Handle weeks for toDate
    if (moment(formattedNewValue).format('MM-DD') === '01-01') {
      formik.setFieldValue("toWeek", 1);
      setSelectedStaffToWeek(1);
    } else {
      formik.setFieldValue("toWeek", moment(formattedNewValue).isoWeek());
      setSelectedStaffToWeek(moment(formattedNewValue).isoWeek());
    }

    // If toDate is before fromDate, update fromDate**
    if (subModLabel === 1.2) {
      if (fromDateValue && moment(formattedNewValue).isBefore(fromDateValue)) {
        formik.setFieldValue("fromDate", formattedNewValue);
        setSelectedStaffFromDate(formattedNewValue);
        setSelectedFromDate(formattedNewValue);

        if (moment(formattedNewValue).format('MM-DD') === '01-01') {
          formik.setFieldValue("fromWeek", 1);
          setSelectedStaffFromWeek(1);
        } else {
          formik.setFieldValue("fromWeek", moment(formattedNewValue).isoWeek());
          setSelectedStaffFromWeek(moment(formattedNewValue).isoWeek());
        }
      }

      // Adjust fromDate if toDate is > 3 months after current fromDate
      if (fromDateValue && moment(formattedNewValue).diff(moment(fromDateValue), 'months') >= 3) {
        const adjustedFromDate = moment(formattedNewValue).subtract(3, 'months').format('YYYY-MM-DD');
        formik.setFieldValue("fromDate", adjustedFromDate);
        setSelectedStaffFromDate(adjustedFromDate);
        setSelectedFromDate(adjustedFromDate);

        if (moment(adjustedFromDate).format('MM-DD') === '01-01') {
          formik.setFieldValue("fromWeek", 1);
          setSelectedStaffFromWeek(1);
        } else {
          formik.setFieldValue("fromWeek", moment(adjustedFromDate).isoWeek());
          setSelectedStaffFromWeek(moment(adjustedFromDate).isoWeek());
        }
      }
    }
  }
  const [invalidDate, setInvalidDate] = useState({
    fromDate: false,
    toDate: false
  })
  const handleFromWeek = (e) => {
    // reset remaining fields
    setFieldValue("group", '');
    setSelectedGroupFilter('');
    setSelectedScoreCardSingle('');
    setselectedStaFilter('');
    setFieldValue('scoreCardSingle', '');
    setFieldValue("scoreCard", []);
    setFieldValue('groupField', {});
    setFieldValue('teamField', {
      id: '', name: 'All'
    });
    setFieldValue('multiScorecardField', []);
    setFieldValue('singleScorecardField', {});
    setFieldValue("eventField", {
      eventType: '',
      eventTypeEventType: "All",
      scoreCard: ''
    })
    setFieldValue('eventSubField', {
      eventSubType: '',
      subType: 'All',
      scorecard: ''
    })
    setFieldValue("supervisorField", {
      supervisorUserFirstName: 'All',
      supervisorUserLastName: '',
      supervisor: ''
    });
    setFieldValue("staffFieldWithAll", {
      staffUserFirstName: 'All',
      staffUserLastName: '',
      supervisor: ''
    });

    moment.updateLocale('en', {
      week: {
        dow: 1
      }
    });
    const newFromDate = moment().week(e.target.value).startOf('week');
    formik.setFieldValue("fromWeek", e.target.value);
    setSelectedStaffFromWeek(e.target.value);
    setSelectedFromDate(newFromDate);
    formik.setFieldValue("fromDate", newFromDate);

    const formattedNewValue = moment(newFromDate).format('YYYY-MM-DD');
    const today = moment().format('YYYY-MM-DD');

    // checking 
    if (moment(formattedNewValue).isAfter(today)) {
      setInvalidDate(() => ({
        fromDate: true,
        toDate: false
      }));
    } else {
      setInvalidDate(() => ({
        fromDate: false,
        toDate: false
      }));
    }

    // set fromDate to creation date of user -when week selection
    const accessDate = new Date(dataCreatedFrom)
    const modifiedAccessDate = moment(accessDate).format('YYYY-MM-DD')
    if (moment(newFromDate).isBefore(modifiedAccessDate)) {
      formik.setFieldValue("fromDate", newFromDate);
    }
    if (subModLabel === 1.2) {
      // Calculate new toDate = fromDate + 3 months
      const newToDate = moment(newFromDate).add(3, 'months').format('YYYY-MM-DD');

      if (moment(newToDate).isAfter(today)) {
        // Update toDate fields and set today date- if todate is going to set future date
        formik.setFieldValue("toDate", today);
        setSelectedStaffToDate(today);
        setSelectedToDate(today);

        // update toWeek 
        const newToWeek = moment(today).isoWeek();
        formik.setFieldValue("toWeek", newToWeek);
        setSelectedStaffToWeek(newToWeek);
      } else {
        // Update toDate fields too
        formik.setFieldValue("toDate", newToDate);
        setSelectedStaffToDate(newToDate);
        setSelectedToDate(newToDate);

        // update toWeek 
        const newToWeek = moment(newToDate).isoWeek();
        formik.setFieldValue("toWeek", newToWeek);
        setSelectedStaffToWeek(newToWeek);
      }



      // Ensure toDate is not in the future and is after fromDate
      //   moment(formattedNewValue).isAfter(today),
      //   moment(formik.values.toDate).isAfter(today))
      if (moment(formattedNewValue).isAfter(today) || moment(formik.values.toDate).isAfter(today)) {
        let adjustedToDate = moment(formattedNewValue).format('YYYY-MM-DD');

        if (moment(adjustedToDate).isAfter(today)) {
          adjustedToDate = today;
        }

        formik.setFieldValue("toDate", adjustedToDate);
        setSelectedStaffToDate(adjustedToDate);
        setSelectedToDate(adjustedToDate);

        if (moment(adjustedToDate).format('MM-DD') === '01-01') {
          formik.setFieldValue("toWeek", 1);
          setSelectedStaffToWeek(1);
        } else {
          formik.setFieldValue("toWeek", moment(adjustedToDate).isoWeek());
          setSelectedStaffToWeek(moment(adjustedToDate).isoWeek());
        }
      }
    }
  }

  const handleToWeek = (e) => {
    // reset remaining fields
    setFieldValue("group", '');
    setSelectedGroupFilter('');
    setSelectedScoreCardSingle('');
    setselectedStaFilter('');
    setFieldValue('scoreCardSingle', '');
    setFieldValue("scoreCard", []);
    setFieldValue('groupField', {});
    setFieldValue('teamField', {
      id: '', name: 'All'
    });
    setFieldValue('multiScorecardField', []);
    setFieldValue('singleScorecardField', {});
    setFieldValue("eventField", {
      eventType: '',
      eventTypeEventType: "All",
      scoreCard: ''
    })
    setFieldValue('eventSubField', {
      eventSubType: '',
      subType: 'All',
      scorecard: ''
    })
    setFieldValue("supervisorField", {
      supervisorUserFirstName: 'All',
      supervisorUserLastName: '',
      supervisor: ''
    });
    setFieldValue("staffFieldWithAll", {
      staffUserFirstName: 'All',
      staffUserLastName: '',
      supervisor: ''
    });

    moment.updateLocale('en', {
      week: {
        dow: 1
      }
    });
    formik.setFieldValue("toWeek", e.target.value);
    const newToDate = moment().week(e.target.value).endOf('week');
    setSelectedStaffToWeek(e.target.value);
    setSelectedToDate(moment().week(e.target.value).endOf('week'));
    formik.setFieldValue("toDate", moment().week(e.target.value).endOf('week'));

    if (subModLabel === 1.2) {
      // 2. Calculate new fromDate = toDate - 3 months
      const newFromDate = moment(newToDate).subtract(3, 'months').format('YYYY-MM-DD');
      const accessDate = new Date(dataCreatedFrom)
      const modifiedAccessDate = moment(accessDate).format('YYYY-MM-DD')
      if (moment(newFromDate).isBefore(modifiedAccessDate)) {
        formik.setFieldValue("fromDate", modifiedAccessDate);
        setSelectedStaffFromDate(modifiedAccessDate);
        setSelectedFromDate(modifiedAccessDate);
        // update fromWeek automatically
        const newFromWeek = moment(modifiedAccessDate).isoWeek();
        formik.setFieldValue("fromWeek", newFromWeek);
        setSelectedStaffFromWeek(newFromWeek);
      } else {
        // Update fromDate 
        formik.setFieldValue("fromDate", newFromDate);
        setSelectedStaffFromDate(newFromDate);
        setSelectedFromDate(newFromDate);
        // update fromWeek automatically
        const newFromWeek = moment(newFromDate).isoWeek();
        formik.setFieldValue("fromWeek", newFromWeek);
        setSelectedStaffFromWeek(newFromWeek);
      }
    }
    // If fromDate is changed, adjust toDate
    const formattedNewValue = moment(newToDate).format('YYYY-MM-DD');
    const today = moment().format('YYYY-MM-DD');
    if (moment(formattedNewValue).isAfter(today)) {
      const newToDate = moment(today).format('YYYY-MM-DD');// ensure no future date

      setFieldValue("toDate", newToDate);
      setSelectedToDate(newToDate);
      setSelectedStaffToDate(newToDate);

      formik.setFieldValue("toWeek", moment(newToDate).isoWeek());
      setSelectedStaffToWeek(moment(newToDate).isoWeek());
    }

  }

  const handleFilterByChange = (event) => {
    const filterBy = event.target.value;
    // setFieldValue("filterByRange", filterBy);
    // setScorecardType(event.target.value);
    switch (filterBy) {

      case 'Score Date':
        setFieldValue("filterByRange", 'Score Date');
        setFieldValue("filterBy", 'created_at');
        setSelectedFilterBy('Score Date');
        setSelectedFilterByValue('created_at');
        break;
      case 'Event Date':
        setFieldValue("filterByRange", 'Event Date');
        setFieldValue("filterBy", 'event_date');
        setSelectedFilterBy('Event Date');
        setSelectedFilterByValue('event_date');
        break;
      case 'Last Edit Date':
        setFieldValue("filterByRange", 'Last Edit Date');
        setFieldValue("filterBy", 'updated_at');
        setSelectedFilterBy('Last Edit Date');
        setSelectedFilterByValue('updated_at');
        break;
      default:
        setFieldValue("filterByRange", 'Last Edit Date');
        setFieldValue("filterBy", 'updated_at');
        setSelectedFilterBy('updated_at');
        setSelectedFilterByValue('updated_at');
        break;
    }

  };

  const handleCloseFields = () => {
    updateState('openGroupField', false)
    updateState('openSingleScorecardField', false)
    updateState('openMultiScorecardField', false)
    updateState('openEventTypeField', false)
    updateState('openEventSubTypeField', false)
    updateState('openTeamField', false)
    updateState('openSupervisorField', false)
    updateState('openStaffField', false)
    updateState('openSectionField', false)
    updateState('openQuestionField', false)
    updateState('openEvalField', false)

  };
  const handleOpenGroupFields = async () => {

    const groupFilterObj = {
      fromDate: moment(values.fromDate).format('YYYY-MM-DD'),
      toDate: moment(values.toDate).format('YYYY-MM-DD'),
      filterBy: values.filterBy,
      sup_grp:
        loggedUserData?.staff?.staffType === 20 || loggedUserData?.staff?.staffType === 30
          ? loggedUserData?.groups?.map((obj) => obj.id)
          : ''
    };

    updateState('openGroupField', true)
    await getScoreLogGroups(groupFilterObj);

  };


  const handleGroupChange = (event, newVal) => {

    // Resetting remaining fields
    setFieldValue("teams", '');
    setFieldValue("scoreCard", []);
    setFieldValue("scoreCardSingle", "");
    setFieldValue("scoreCardSingle2", "");
    setFieldValue("eventType", '');
    setFieldValue("eventTypeEventSubType", '');
    setFieldValue("staff", '');
    setFieldValue("scoreCardCategory", '');
    setFieldValue("evaluator", '');
    setFieldValue("supervisor", '');
    setFieldValue("highlightValue", '');
    setFieldValue("section", '');
    setFieldValue("question", '');
    setFieldValue("evaluator", '');
    setFieldValue('dataTag', [])
    setFieldValue('dataTagsOperator', '')
    // setselectedStaFilter([])
    // setSelectedScoreCardSingle('')
    // setSelectedSupervisorFilter('')
    // setSelectedTeamFilter('')

    // show the data to set when open the filter
    setFieldValue('groupField', newVal)

    setFieldValue('group', newVal?.id ?? '');
    // setSelectedGroupFilter(newVal?.id ?? '');

    // redux state fields
    setFieldValue('teamField', {
      id: '', name: 'All'
    });
    setFieldValue('multiScorecardField', []);
    setFieldValue('singleScorecardField', {});
    setFieldValue("eventField", {
      eventType: '',
      eventTypeEventType: "All",
      scoreCard: ''
    })
    setFieldValue('eventSubField', {
      eventSubType: '',
      subType: 'All',
      scorecard: ''
    })
    setFieldValue("supervisorField", {
      supervisorUserFirstName: 'All',
      supervisorUserLastName: '',
      supervisor: ''
    });
    setFieldValue("staffFieldWithAll", {
      staffUserFirstName: 'All',
      staffUserLastName: '',
      supervisor: ''
    });
  };

  const handleDataTags = (event) => {
    setFieldValue("dataTag", (event.target.value).flat(100));
    // setselectedDataTag((event.target.value).flat(100))
    // localStorage.setItem('selectedDataTagValue', JSON.stringify(event.target.value))

  }

  const handleAnyOfTag = () => {
    setFieldValue('allOfTag', '')
    setFieldValue('anyOfTag', '10')
    setIsAnyOfTag(true)
    setIsAllOfTag(false)
  }

  const handleAllOfTag = () => {
    setFieldValue('anyOfTag', '')
    setFieldValue('allOfTag', '20')
    setIsAnyOfTag(false)
    setIsAllOfTag(true)
  }
  const handleOpenTeamFields = () => {
    updateState('openTeamField', true)

    const teamFilterObj =
    {
      "fromDate": moment(values.fromDate).format('YYYY-MM-DD'),
      "toDate": moment(values.toDate).format('YYYY-MM-DD'),
      "filterBy": values.filterBy,
      "group": values.group,
      "teams": values.teams,
      "scoreCard": '',
      "eventType": '',
      "eventTypeEventSubType": '',
      "supervisor": '',
      "staff": '',
      "scoreCardCategory": '',
      "evaluator": '',
      "highlightValue": '',
      "sup_grp": (loggedUserData?.staff?.staffType === 20 || loggedUserData?.staff?.staffType === 30) ? loggedUserData?.groups?.map(obj => obj.id).join(',') : ''
    }
    getScoreLogTeams(teamFilterObj)
  }
  const handleTeamChange = (event, newVal) => {
    // Resetting remaining fields
    setFieldValue("scoreCard", []);
    setFieldValue("scoreCardSingle", "");
    setFieldValue("scoreCardSingle2", "");
    setFieldValue("eventType", '');
    setFieldValue("eventTypeEventSubType", '');
    setFieldValue("staff", '');
    setFieldValue("scoreCardCategory", '');
    setFieldValue("evaluator", '');
    setFieldValue("supervisor", '');
    setFieldValue("highlightValue", '');
    setFieldValue("section", '');
    setFieldValue("question", '');
    setFieldValue("evaluator", '');
    setFieldValue('dataTag', [])
    setFieldValue('dataTagsOperator', '10')

    setFieldValue("teams", newVal?.id);
    // setSelectedTeamFilter(newVal?.id);
    setFieldValue('teamField', newVal)

    setFieldValue("scoreCard", []);
    setFieldValue("scoreCardSingle", '');
    // setselectedStaFilter([]);
    // setSelectedScoreCardSingle('')

    // redux state fields
    setFieldValue('multiScorecardField', []);
    setFieldValue('singleScorecardField', {});
    setFieldValue("eventField", {
      eventType: '',
      eventTypeEventType: "All",
      scoreCard: ''
    })
    setFieldValue('eventSubField', {
      eventSubType: '',
      subType: 'All',
      scorecard: ''
    })
    setFieldValue("supervisorField", {
      supervisorUserFirstName: 'All',
      supervisorUserLastName: '',
      supervisor: ''
    });
    setFieldValue("staffFieldWithAll", {
      staffUserFirstName: 'All',
      staffUserLastName: '',
      supervisor: ''
    });

  };
  const handleOpenSupervisorField = () => {
    updateState('openSupervisorField', true)
    const supFilterObj =
    {
      "fromDate": moment(values.fromDate).format('YYYY-MM-DD'),
      "toDate": moment(values.toDate).format('YYYY-MM-DD'),
      "filterBy": values.filterBy,
      "group": values.group,
      "teams": values.teams,
      "scoreCard": values.scoreCard,
      "eventType": values.eventType,
      "eventTypeEventSubType": values.eventTypeEventSubType,
      "supervisor": '',
      "staff": values.staff,
      "scoreCardCategory": '',
      "evaluator": values.evaluator,
      "highlightValue": values.highlightValue,
      "sup_grp": (loggedUserData?.staff?.staffType === 20 || loggedUserData?.staff?.staffType === 30) ? loggedUserData?.groups?.map(obj => obj.id).join(',') : ''
    }
    getScoreLogSupervisor(supFilterObj);
  }
  const handleSupervisorChange = (event, newVal) => {
    setFieldValue("supervisor", newVal?.supervisor);

    setFieldValue("supervisorField", newVal);
    // setSelectedSupervisorFilter(newVal?.supervisor);
  };

  const handleOpenMultiScorecardFields = async () => {
    updateState('openMultiScorecardField', true)
    const scoreCardfilterObj =
    {
      "fromDate": moment(values.fromDate).format('YYYY-MM-DD'),
      "toDate": moment(values.toDate).format('YYYY-MM-DD'),
      "filterBy": values.filterBy,
      "group": values.group,
      "teams": values.teams,
      "scoreCard": '',
      "eventType": '',
      "eventTypeEventSubType": '',
      "supervisor": '',
      "staff": '',
      "scoreCardCategory": '',
      "evaluator": '',
      "highlightValue": '',
      "sup_grp": (loggedUserData?.staff?.staffType === 20 || loggedUserData?.staff?.staffType === 30) ? loggedUserData?.groups?.map(obj => obj.id).join(',') : ''
    }
    await getScoreLogScorecards(scoreCardfilterObj);

  }

  const handleMultiScorecardChange = (event, newValue) => {
    setFieldValue("eventType", '');
    setFieldValue("eventTypeEventSubType", '');
    setFieldValue("staff", '');
    setFieldValue("scoreCardCategory", '');
    setFieldValue("evaluator", '');
    setFieldValue("supervisor", '');
    setFieldValue("highlightValue", '');
    setFieldValue("section", '');
    setFieldValue("question", '');
    setFieldValue("evaluator", '');
    setFieldValue("dataTag", []);
    const value = []
    const allValue = [];
    newValue?.map(option => {
      value.push(option?.scoreCard)
      allValue.push(option)
      return 0
    });
    setFieldValue("scoreCard", value ?? []);
    setFieldValue("scoreCardSingle", value?.length > 0 ? value[0] : '');

    setFieldValue("multiScorecardField", allValue)
    setFieldValue("singleScorecardField", allValue?.length > 0 ? allValue[0] : {})

    // setselectedStaFilter(value ?? []);
    // setSelectedScoreCardSingle(value?.length > 0 ? value[0] : '')

    // redux state fields
    setFieldValue("eventField", {
      eventType: '',
      eventTypeEventType: "All",
      scoreCard: ''
    })
    setFieldValue('eventSubField', {
      eventSubType: '',
      subType: 'All',
      scorecard: ''
    })
    setFieldValue("supervisorField", {
      supervisorUserFirstName: 'All',
      supervisorUserLastName: '',
      supervisor: ''
    });
    setFieldValue("staffFieldWithAll", {
      staffUserFirstName: 'All',
      staffUserLastName: '',
      supervisor: ''
    });

    // if (subModLabel === 1.9 || subModLabel === 1.1) {
    const filterScoreCardObj = {
      "fromDate": moment(values.fromDate).format('YYYY-MM-DD'),
      "toDate": moment(values.toDate).format('YYYY-MM-DD'),
      "filterBy": values.filterBy || 'created_at',
      "scoreCard": value ?? '',
    }
    getDataTagsByScoreCard(filterScoreCardObj)
    // localStorage.setItem('selectedDataTagValue', JSON.stringify([]))

    // setselectedDataTag([])
    // }
  };

  const handleOpenSingleScorecardFields = async () => {
    updateState('openSingleScorecardField', true)
    const scoreCardfilterObj =
    {
      "fromDate": moment(values.fromDate).format('YYYY-MM-DD'),
      "toDate": moment(values.toDate).format('YYYY-MM-DD'),
      "filterBy": values.filterBy,
      "group": values.group,
      "teams": values.teams,
      "scoreCard": '',
      "eventType": '',
      "eventTypeEventSubType": '',
      "supervisor": '',
      "staff": '',
      "scoreCardCategory": '',
      "evaluator": '',
      "highlightValue": '',
      "sup_grp": (loggedUserData?.staff?.staffType === 20 || loggedUserData?.staff?.staffType === 30) ? loggedUserData?.groups?.map(obj => obj.id).join(',') : ''
    }
    await getScoreLogScorecards(scoreCardfilterObj);

  }

  const handleSingleScorecardChange = (event, newValue) => {
    setFieldValue("eventType", '');
    setFieldValue("eventTypeEventSubType", '');
    setFieldValue("staff", '');
    setFieldValue("highlightValue", '');
    setFieldValue("section", '');

    setFieldValue('scoreCardSingle', newValue?.scoreCard ?? '')
    setFieldValue("scoreCard", [newValue?.scoreCard] ?? []);

    setFieldValue('singleScorecardField', newValue)
    setFieldValue("multiScorecardField", [newValue] ?? [])
    // localStorage.setItem('selectedDataTagValue', JSON.stringify([]))

    setFieldValue("dataTag", []);

    // redux state fields
    setFieldValue("eventField", {
      eventType: '',
      eventTypeEventType: "All",
      scoreCard: ''
    })
    setFieldValue('eventSubField', {
      eventSubType: '',
      subType: 'All',
      scorecard: ''
    })
    setFieldValue("supervisorField", {
      supervisorUserFirstName: 'All',
      supervisorUserLastName: '',
      supervisor: ''
    });
    setFieldValue("staffFieldWithAll", {
      staffUserFirstName: 'All',
      staffUserLastName: '',
      supervisor: ''
    });
    // setselectedDataTag([])
    // setselectedStaFilter([newValue?.scoreCard] || []);

    // setSelectedScoreCardSingle(newValue?.scoreCard ?? '')
    const filterScoreCardObj = {
      "fromDate": moment(values.fromDate).format('YYYY-MM-DD'),
      "toDate": moment(values.toDate).format('YYYY-MM-DD'),
      "filterBy": values.filterBy || 'created_at',
      "scoreCard": newValue?.scoreCard !== '' ? newValue?.scoreCard : '',
    }
    getDataTagsByScoreCard(filterScoreCardObj)
  }

  const handleOpenStaffFields = () => {
    updateState('openStaffField', true)
    const empFilterObj =
    {
      "fromDate": moment(values.fromDate).format('YYYY-MM-DD'),
      "toDate": moment(values.toDate).format('YYYY-MM-DD'),
      "filterBy": values.filterBy,
      "group": values.group,
      "teams": values.teams,
      "scoreCard": (subModLabel === 1.4 || subModLabel === 1.1 || subModLabel === 1.9) ? values.scoreCard : values.scoreCardSingle,
      "eventType": values.eventType,
      "eventTypeEventSubType": values.eventTypeEventSubType,
      "supervisor": values.supervisor,
      "staff": '',
      "scoreCardCategory": '',
      "evaluator": values.evaluator,
      "highlightValue": values.highlightValue,
      "sup_grp": (loggedUserData?.staff?.staffType === 20 || loggedUserData?.staff?.staffType === 30) ? loggedUserData?.groups?.map(obj => obj.id).join(',') : ''
    }
    getScoreLogEmployee(empFilterObj);

  }

  const handleStaffChange = (event, newVal) => {
    setFieldValue("highlightValue", '');
    setFieldValue("staff", newVal?.staff);
    // setFieldValue("staffField", newVal);
    setFieldValue("staffFieldWithAll", newVal);

    // setSelectedStaffFilter(event.target.value);
  };

  const handleStaffWithAllChange = (event, newVal) => {
    setFieldValue("highlightValue", '');
    setFieldValue("staff", newVal?.staff);
    setFieldValue("staffFieldWithAll", newVal);
    // setSelectedStaffFilter(event.target.value);
  };

  const handleAdvancedFilters = () => {
    setAdvanceFilters((advanceFilters) => !advanceFilters);
  };

  const handleOpenEventTypeField = () => {
    updateState('openEventTypeField', true)
    const evntTypeFilterObj =
    {
      "fromDate": moment(values.fromDate).format('YYYY-MM-DD'),
      "toDate": moment(values.toDate).format('YYYY-MM-DD'),
      "filterBy": values.filterBy,
      "group": values.group,
      "teams": values.teams,
      "scoreCard": values.scoreCard?.length > 0 ? values.scoreCard : (values.scoreCardSingle),
      "eventType": '',
      "eventTypeEventSubType": '',
      "supervisor": '',
      "staff": '',
      "scoreCardCategory": '',
      "evaluator": '',
      "highlightValue": '',
      "sup_grp": (loggedUserData?.staff?.staffType === 20 || loggedUserData?.staff?.staffType === 30) ? loggedUserData?.groups?.map(obj => obj.id).join(',') : ''
    }
    getScoreLogEventType(evntTypeFilterObj);

  }
  const handleEventTypeChange = (event, newVal) => {
    // setSelectedFilterEventType(newVal?.eventType)
    // for 1.8 module
    // setSelectedEventTypeFilter(event.target.value)
    // setting name for 1.1 module
    setFieldValue("eventTypeEventType", newVal?.eventType)

    setFieldValue('eventField', newVal);
    setFieldValue('eventType', newVal?.eventType);


    // redux state fields
    setFieldValue('eventSubField', {
      eventSubType: '',
      subType: 'All',
      scorecard: ''
    })
    setFieldValue("supervisorField", {
      supervisorUserFirstName: 'All',
      supervisorUserLastName: '',
      supervisor: ''
    });
    setFieldValue("staffFieldWithAll", {
      staffUserFirstName: 'All',
      staffUserLastName: '',
      supervisor: ''
    });
  };

  const handleOpenEventSubTypeField = () => {
    updateState('openEventSubTypeField', true)
    const evntSubTypeFilterObj =
    {
      "fromDate": moment(values.fromDate).format('YYYY-MM-DD'),
      "toDate": moment(values.toDate).format('YYYY-MM-DD'),
      "filterBy": values.filterBy,
      "group": values.group,
      "teams": values.teams,
      "scoreCard": values.scoreCard?.length > 0 ? values.scoreCard : (values.scoreCardSingle),
      "eventType": values.eventType,
      "eventTypeEventSubType": '',
      "supervisor": '',
      "staff": '',
      "scoreCardCategory": '',
      "evaluator": '',
      "highlightValue": '',
      "sup_grp": (loggedUserData?.staff?.staffType === 20 || loggedUserData?.staff?.staffType === 30) ? loggedUserData?.groups?.map(obj => obj.id).join(',') : ''
    }
    getScoreLogEventSubType(evntSubTypeFilterObj);

  }
  const handleSubTypeChange = (event, newVal) => {
    // setSelectedFilterSubType(newVal?.eventSubType)
    setFieldValue("eventTypeEventSubType", newVal?.eventSubType)
    // for 1.8 module --
    // setSelectedEventSubTypeFilter(newVal?.eventSubType)
    // setting name for 1.1 module
    // setFieldValue("eventSubTypeEventSubType", value.props.children)

    setFieldValue('eventSubField', newVal)
    setFieldValue('eventTypeEventSubType', newVal?.eventSubType);
    // redux state fields
    setFieldValue("supervisorField", {
      supervisorUserFirstName: 'All',
      supervisorUserLastName: '',
      supervisor: ''
    });
    setFieldValue("staffFieldWithAll", {
      staffUserFirstName: 'All',
      staffUserLastName: '',
      supervisor: ''
    });

  };

  const handleOpenSectionField = () => {
    updateState('openSectionField', true)
    // if(values?.scoreCardSingle) {
    getSectionDropdown(values?.scoreCard);
    // }
  }
  // function for select section field
  const handleSectionField = (event, newVal) => {
    setFieldValue('section', newVal?.id)

    setFieldValue('sectionField', newVal)
    // setSelectedSelectionFilter(event.target.value)

  }
  const handleOpenQuestionField = () => {
    updateState('openQuestionField', true)

    getQuestionsAnswerByStaff(values.scoreCardSingle, values.section);
  }
  // function for question field
  const handleQuestionField = (event, newVal) => {
    setFieldValue('question', newVal.id)

    setFieldValue('questionField', newVal)
    // setSelectedQuestionFilter(event.target.value)

  }

  const handleOpenEvalField = () => {
    updateState('openEvalField', true)
    const filterObj =
    {
      "fromDate": moment(values.fromDate).format('YYYY-MM-DD'),
      "toDate": moment(values.toDate).format('YYYY-MM-DD'),
      "filterBy": values.filterBy,
      "group": values.group,
      "teams": values.teams,
      "scoreCard": subModLabel === 1.5 ? values.scoreCardSingle2 : values.scoreCard,
      "eventType": values.eventType,
      "eventTypeEventSubType": values.eventTypeEventSubType,
      "supervisor": values.supervisor,
      "staff": values.staff,
      "scoreCardCategory": '',
      "evaluator": '',
      "highlightValue": values.highlightValue,
      "sup_grp": (loggedUserData?.staff?.staffType === 20 || loggedUserData?.staff?.staffType === 30) ? loggedUserData?.groups?.map(obj => obj.id).join(',') : ''
    }
    getScoreLogEvaluator(filterObj)
  }
  const handleEvalChange = (event, newVal) => {
    setFieldValue("evaluator", newVal?.evaluator)

    setFieldValue("evaluatorField", newVal)
  }


  const renderOptions = (props, option) => {
    return <li {...props} key={`${option?.scoreCard} - ${option?.scoreCardName} --S`} style={{ color: option?.scoreCardIsArchive ? 'red' : '' }}>
      {loadingState?.scorecardLoading ? 'Loading...' : option?.scoreCardName}
    </li>

  }
  const renderGroupOptions = (props, option) => {
    return <li {...props} key={`${option?.id} - ${option?.name} - G`}>
      {!loadingState?.groupLoading ? option?.name : 'Loading...'}
    </li>
  }

  const renderTeamOptions = (props, option) => {
    return <li {...props} key={`${option?.id} -- ${option?.name} - T`}>
      {!loadingState?.teamLoading ? option?.name : 'Loading...'}
    </li>
  }

  const renderEventOptions = (props, option) => {
    return <li {...props} key={`${option?.eventType} -${option?.eventTypeEventType} - E`}>
      {
        loadingState?.eventTypeLoading ? 'Loading...' : <>
          <Typography sx={{ fontSize: '14px', display: 'inline' }}>{option?.eventTypeEventType}</Typography>&nbsp;
          <Typography sx={{
            display: 'inline-block', fontStyle: 'italic',
            fontSize: '12px', fontWeight: 'bold'
          }}>
            {
              option?.scorecard ? `(${option?.scorecard})` : ''
            }
          </Typography>
        </>
      }

    </li >
  }


  const renderEventSubOptions = (props, option) => {
    return <li {...props} key={`${option?.eventSubType} - ${option?.subType} - ES`}>
      {
        loadingState?.eventSubTypeLoading ? 'Loading...' : <>
          <Typography sx={{ fontSize: '14px', display: 'inline' }}>{option?.subType}</Typography>&nbsp;
          <Typography sx={{
            display: 'inline-block', fontStyle: 'italic',
            fontSize: '12px', fontWeight: 'bold'
          }}>
            {
              option?.scorecard ? `(${option?.scorecard})` : ''
            }
          </Typography>
        </>
      }

    </li >
  }

  const renderSupervisorOptions = (props, option) => {
    return <li {...props} key={`${option?.supervisor} - ${option?.supervisorUserFirstName} ${option?.supervisorUserLastName}`}>
      {!loadingState?.supervisorLoading ? `${option.supervisorUserFirstName} ${option.supervisorUserLastName}` : 'Loading...'}
    </li>
  }

  const renderStaffOptions = (props, option) => {
    return <li {...props} key={`${option?.staffUserFirstName} -- ${option?.staffUserLastName}`}>
      {!loadingState?.staffLoading ? `${option.staffUserFirstName} ${option.staffUserLastName}` : 'Loading...'}
    </li>
  }

  const renderSectionOptions = (props, option) => {
    return <li {...props} key={`${option?.id} - ${option?.name} - Sec`}>
      {!loadingState?.sectionLoading ? option?.name ?? '--' : 'Loading...'}
    </li>
  }

  const renderQuestionOptions = (props, option) => {
    return <li {...props} key={`${option?.id} - ${option?.question} Q`}>
      {!loadingState?.questionLoading ? option?.question : 'Loading...'}
    </li>
  }

  const renderEvalOptions = (props, option) => {
    return <li {...props} key={`${option?.id} - ${option?.evaluatorFirstName} ${option?.evaluatorLastName}`}>
      {!loadingState?.evaluatorLoading ? `${option?.evaluatorFirstName} ${option?.evaluatorLastName}` : 'Loading...'}
    </li>
  }
  const groupOptions = useMemo(() => {
    if (Array.isArray(reportsScoreLogGroups)) {
      return subModLabel === 1.11
        ? [{ id: '', name: 'All' }, ...reportsScoreLogGroups]
        : reportsScoreLogGroups;
    }
    return subModLabel === 1.11
      ? [{ id: '', name: 'All' }]
      : reportsScoreLogGroups;
  }, [subModLabel, reportsScoreLogGroups]);


  return (
    <div>

      {addUserButton &&
        <Button variant="contained" onClick={handleClickOpen} className="halloween-animation">
          Filter
        </Button>
      }

      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <FormikProvider value={formik}>
          <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
            <DialogTitle sx={{ pb: 2 }} >
              <h3>Analytics Report Filter {subModLabel === 1.31 ? '1.3' : subModLabel} </h3>
              <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={{
                  position: 'absolute',
                  right: 8,
                  top: 15,
                  color: (theme) => theme.palette.grey[500],
                }}
              >
                <Close />
              </IconButton>
            </DialogTitle>
            <Divider />
            <DialogContent style={{ paddingTop: '20px' }}>
              <Stack spacing={3}>

                <Stack direction={{ xs: 'column', sm: 'row' }} sx={{ p: 0, justifyContent: 'end' }}>

                  {/* <FormControl fullWidth > */}
                  <Button startIcon={advanceFilters ? <VisibilityOffIcon /> : <VisibilityIcon />} sx={{ p: 0 }} onClick={handleAdvancedFilters}> {advanceFilters ? 'Hide Advanced Filters' : 'Show Advanced Filters'} </Button>
                  {/* </FormControl> */}
                </Stack>
                <Divider />


                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <FormControl fullWidth>
                    <InputLabel id="date-range-label">Date Range</InputLabel>
                    <Select
                      // defaultValue='This Month'
                      labelId="date-range-label"
                      id="date-range-select-small"
                      value={values.dateRange}
                      label="Date Range"
                      {...getFieldProps('dateRange')}
                      onChange={(e) => { handleDateRangeChange(e) }}
                    >
                      {dateRange?.map((item) => (
                        (subModLabel === 1.2) ?
                          (item?.dateRange !== 'This Year' && item?.dateRange !== 'Last Year') &&
                          <MenuItem key={item.id} id={item.id} value={item.dateRange}>
                            {item.dateRange}
                          </MenuItem >

                          :
                          <MenuItem key={item.id} id={item.id} value={item.dateRange}>
                            {item.dateRange}
                          </MenuItem >

                      )
                      )}


                    </Select>
                  </FormControl>

                  <FormControl fullWidth>
                    <InputLabel id="filter-by-label">Filter By</InputLabel>
                    <Select
                      // defaultValue='Score Date'
                      name='filterByRange'
                      labelId="filter-by-label"
                      id="filter-by-select-small"
                      value={values.filterByRange}
                      label="Filter By"
                      {...getFieldProps('filterByRange')}
                      onChange={handleFilterByChange}
                    >
                      {filterBy?.map((item) => (
                        <MenuItem key={item.id} id={item.id} value={item.type}>
                          {item.type}
                        </MenuItem >
                      ))}
                    </Select>
                  </FormControl>
                </Stack>

                {customFilters &&
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                      <Box sx={{ width: "50%" }}>
                        <DesktopDatePicker
                          label="Date From"
                          inputFormat="yyyy/MM/dd"
                          name="fromDate"
                          minDate={new Date(dataCreatedFrom)}
                          disableFuture
                          {...getFieldProps('fromDate')}
                          onChange={(newValue) => {
                            handleFromDate(newValue)
                          }}
                          renderInput={(params) => <TextField fullWidth {...params} />}
                        />

                        {formik.errors.fromDate && formik.touched.fromDate && <Typography variant="caption" sx={{ color: "red", ml: 1 }}>{formik.errors.fromDate}</Typography>}

                      </Box>

                      <Box sx={{ width: "50%" }}>
                        <DesktopDatePicker
                          label="Date To"
                          inputFormat="yyyy/MM/dd"
                          name="toDate"
                          minDate={new Date(dataCreatedFrom)}
                          disableFuture
                          {...getFieldProps('toDate')}
                          onChange={(newValue) => {
                            handleToDate(newValue)
                          }}
                          renderInput={(params) => <TextField fullWidth {...params} />}
                        />


                        {formik.errors.toDate && formik.touched.toDate && <Typography variant="caption" sx={{ color: "red", ml: 1 }}>{formik.errors.toDate}</Typography>}
                      </Box>
                    </Stack>
                  </LocalizationProvider>
                }
                {customFilters && <Stack direction="row" sx={{ width: "100%", mb: 2 }} spacing={2}>
                  <Box sx={{ width: "50%" }}>
                    <TextField
                      fullWidth
                      required
                      // value={formik.values.fromWeek}
                      value={formik.values.fromWeek ?? null}
                      multiple={false}
                      select
                      name="fromWeek"
                      onChange={(e) => {
                        handleFromWeek(e)
                      }}

                    >
                      {fromWeekNo?.map((item) => (
                        <MenuItem key={item} id={item} value={item}>
                          Week&nbsp;{item}
                        </MenuItem >
                      ))}

                    </TextField>

                  </Box>
                  <Box sx={{ width: "50%" }}>
                    <TextField
                      fullWidth
                      multiple={false}
                      value={formik.values.toWeek}
                      required
                      select
                      name="toWeek"
                      onChange={(e) => {
                        handleToWeek(e)
                      }}

                    >
                      {toWeekNo?.map((item) => (
                        <MenuItem
                          // disabled={formik.values.fromWeek > item}
                          key={item} id={item} value={item}>
                          Week&nbsp;{item}
                        </MenuItem >
                      ))}
                    </TextField>

                  </Box>

                </Stack>}
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <FormControl fullWidth>
                    <Autocomplete
                      fullWidth
                      open={state?.openGroupField}
                      onOpen={handleOpenGroupFields}
                      onClose={handleCloseFields}
                      // value={selectedGroup ?? null}
                      value={
                        (
                          reportsScoreLogGroups ?
                            (
                              subModLabel === 1.11 ? [{
                                name: 'All', id: ''
                              }].concat(reportsScoreLogGroups) :
                                reportsScoreLogGroups
                            )?.find((option) => option?.id === values?.group) :
                            null
                        )
                        || (values?.groupField && Object.keys(values.groupField).length > 0 ? values.groupField : null)
                        || null
                      }
                      // value={
                      //   reportsScoreLogGroups ?
                      //     (
                      //       subModLabel === 1.11 ? [{
                      //         name: 'All', id: ''
                      //       }].concat(reportsScoreLogGroups) :
                      //         reportsScoreLogGroups
                      //     )?.find((option) => option?.id === values?.group) :
                      //     values?.groupField ?? null
                      // }
                      options={
                        (() => {
                          if (reportsScoreLogGroups) {
                            if (subModLabel === 1.11) {
                              return [{ name: 'All', id: '' }, ...reportsScoreLogGroups];
                            }
                            return reportsScoreLogGroups;
                          }
                          // If API not loaded
                          if (values?.groupField) {
                            return [values.groupField];
                          }

                          return [];
                        })()
                      }
                      // options={groupOptions}
                      getOptionLabel={(option) => option?.name || ""}
                      renderOption={renderGroupOptions}
                      isOptionEqualToValue={(option, value) => {
                        // console.log('option---', option, 'value', value, String(option?.id) === String(value?.id), values);
                        return String(option?.id) === String(value?.id)
                      }}
                      onChange={(event, newValue) => {
                        handleGroupChange(event, newValue);
                      }}
                      id="controllable-states-group"
                      name="group"
                      ListboxProps={{
                        style: {
                          bottom: 0,
                          overflowY: 'auto'
                        }
                      }}
                      renderInput={(params) => <TextField {...params} label="Group"
                        variant="outlined"
                        // error={Boolean(touched.group && errors.group)}
                        // helperText={touched.group && errors.group}
                        error={values?.group === ''}
                        helperText={values?.group === '' ? errors.group : null}
                        required
                      />}
                    />
                  </FormControl>


                  {(subModLabel !== 1.4 && subModLabel !== 1.5 && subModLabel !== 1.8 &&
                    subModLabel !== 1.7 && subModLabel !== 1.6) &&
                    <FormControl fullWidth>
                      <Autocomplete
                        fullWidth
                        open={state?.openTeamField}
                        onOpen={handleOpenTeamFields}
                        onClose={handleCloseFields}
                        value={
                          reportsScoreLogTeams ?
                            ([{
                              name: 'All', id: ''
                            }].concat(reportsScoreLogTeams))?.find((option) => option?.id === values?.teams)
                            :
                            values?.teamField ?? null
                        }
                        options={
                          (() => {
                            if (reportsScoreLogTeams) return [{ name: 'All', id: '' }, ...reportsScoreLogTeams];

                            // If API not loaded
                            if (values?.teamField) return [values.teamField];

                            return [{}];
                          })()
                        }
                        getOptionLabel={(option) => option?.name || ""}
                        renderOption={renderTeamOptions}
                        isOptionEqualToValue={(option, value) => option?.id === value?.id}
                        onChange={(e, newVal) => handleTeamChange(e, newVal)}
                        ListboxProps={{
                          style: {
                            bottom: 0,
                            overflowY: 'auto'
                          }
                        }}
                        renderInput={(params) =>
                          <TextField {...params} label="Teams"
                            variant="outlined"

                          />}

                      />

                    </FormControl>
                  }
                </Stack>

                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  {(subModLabel === 1.4 || subModLabel === 1.1 || subModLabel === 1.9) &&
                    <FormControl fullWidth>
                      <Autocomplete
                        multiple
                        freeSolo
                        open={state?.openMultiScorecardField}
                        onOpen={handleOpenMultiScorecardFields}
                        onClose={handleCloseFields}
                        // value={reportsScoreLogScorecards?.filter((option) => values?.scoreCard?.includes(option?.scoreCard))}
                        value={
                          reportsScoreLogScorecards
                            ? reportsScoreLogScorecards?.filter((option) =>
                              values?.scoreCard?.includes(option?.scoreCard)
                            )
                            : filterFieldsData?.multiScorecardField?.filter((option) =>
                              values?.scoreCard?.includes(option?.scoreCard)
                            ) || []
                        }
                        name='scoreCard'
                        fullWidth
                        options={reportsScoreLogScorecards ?? filterFieldsData?.multiScorecardField ?? []}
                        getOptionLabel={(option) => option?.scoreCardName || ""}
                        renderOption={renderOptions}
                        onChange={(event, newValue) => {
                          handleMultiScorecardChange(event, newValue);
                        }}
                        id="controllable-states-scorecard"
                        isOptionEqualToValue={(option, value) =>
                          String(option?.scoreCard) === String(value?.scoreCard)
                        }
                        renderTags={(value, getTagProps) => {
                          return value.map((option, index) => (
                            <Chip
                              variant="outlined"
                              label={typeof option === "string" ? option : option?.scoreCardName}
                              {...getTagProps({ index })}
                            />
                          ));
                        }}
                        ListboxProps={{
                          style: {
                            bottom: 0,
                            overflowY: 'auto',
                          }
                        }}
                        renderInput={(params) => <TextField {...params} label="Scorecard"

                          variant="outlined"
                          error={((values?.scoreCard?.length === 0) && true)}
                          helperText={(values?.scoreCard?.length === 0) && 'This value is required'}
                          onBlur={formik.handleBlur}
                          required
                        />}

                      />
                    </FormControl>}

                  {(subModLabel === 1.5 || subModLabel === 1.11 || subModLabel === 1.6
                    || subModLabel === 1.2 || subModLabel === 1.3 || subModLabel === 1.31
                    || subModLabel === '1.10' || subModLabel === 1.8
                    || subModLabel === 1.7) && <FormControl fullWidth>
                      <Autocomplete
                        open={state?.openSingleScorecardField}
                        onOpen={handleOpenSingleScorecardFields}
                        onClose={handleCloseFields}
                        fullWidth
                        value={
                          (
                            reportsScoreLogScorecards
                              ? (subModLabel === 1.11 ? [{
                                scoreCardName: 'All', scoreCard: ''
                              }].concat(reportsScoreLogScorecards) :
                                reportsScoreLogScorecards)?.find((option) => option?.scoreCard === values?.scoreCardSingle)
                              : null
                          )
                          || (values?.singleScorecardField && Object.keys(values.singleScorecardField).length > 0 ? values.singleScorecardField : null)
                          || null
                        }
                        options={reportsScoreLogScorecards &&
                          subModLabel === 1.11 ? [{
                            scoreCardName: 'All', scoreCard: ''
                          }].concat(reportsScoreLogScorecards) : reportsScoreLogScorecards ?? []

                        }

                        getOptionLabel={(option) => option?.scoreCardName || ""}
                        renderOption={renderOptions}
                        onChange={(event, newValue) => {
                          handleSingleScorecardChange(event, newValue)

                        }}
                        isOptionEqualToValue={(option, value) => {
                          let equalOptions = false
                          if (option?.scoreCard) {
                            equalOptions = option?.scoreCard === value?.scoreCard
                          } else {
                            equalOptions = filterFieldsData?.singleScorecardField?.scoreCard === value?.scoreCard
                          }
                          // console.log('option---', option, 'value', value, equalOptions, filterFieldsData)
                          return equalOptions
                        }}
                        id="scorecard-controllable-states"
                        ListboxProps={{
                          style: {
                            bottom: 0,
                            overflowY: 'auto'
                          }
                        }}
                        renderInput={(params) => <TextField {...params} label="Scorecard"

                          error={subModLabel === 1.11 ? Boolean((touched.scoreCardSingle && errors.scoreCardSingle)) : ((values?.scoreCardSingle === '') && true)}
                          helperText={subModLabel === 1.11 ? (touched.scoreCardSingle && errors.scoreCardSingle) : (values?.scoreCardSingle === '') && 'This value is required'}
                          variant="outlined"
                          // error={Boolean((touched.scoreCardSingle && errors.scoreCardSingle))}
                          // helperText={(touched.scoreCardSingle && errors.scoreCardSingle)}
                          required
                          onBlur={formik.handleBlur}

                        />}
                      />
                    </FormControl>

                  }
                </Stack>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  {
                    (dataTagByScoreCard?.length > 0 && (subModLabel === 1.4 || subModLabel === 1.9 || subModLabel === 1.6 || subModLabel === '1.10' || subModLabel === 1.1 || subModLabel === 1.11)) && <>
                      <FormControl sx={{ width: "50%" }}>
                        <InputLabel id="data-tag-label">Data Tag(s)</InputLabel>
                        <Select
                          labelId="data-tag-label"
                          id="data-tag-select"
                          multiple
                          value={values.dataTag}
                          {...getFieldProps('dataTag')}
                          input={<OutlinedInput notched label="Data Tag(s)" />}
                          onChange={handleDataTags}
                        >
                          {/* <MenuItem value="">Select Value</MenuItem > */}
                          {dataTagByScoreCard?.map((item, i) => (
                            <MenuItem key={i} id={item.dataTags} value={item.dataTags}>
                              {item.dataTagsName}
                            </MenuItem >
                          ))}
                        </Select>
                      </FormControl>
                    </>
                  }


                  {
                    (dataTagByScoreCard?.length > 0 && (subModLabel === 1.4 || subModLabel === 1.9 || subModLabel === '1.10' || subModLabel === 1.1 || subModLabel === 1.11)) && <>
                      <FormControlLabel
                        // alignItems="flex-end" 
                        // justifyContent="flex-end"
                        name="anyOfTag"
                        sx={{ marginLeft: '0px', marginRight: '0px' }}
                        // value="10"
                        control={<Radio />}
                        label="Any of the Tags"
                        checked={isAnyOfTag}
                        onChange={handleAnyOfTag}
                      />

                      {/* {...getFieldProps('anyOfTag')} */}

                      <FormControlLabel
                        // alignItems="flex-end" 
                        // justifyContent="flex-end"
                        name="allOfTag"
                        sx={{ marginLeft: '0px', marginRight: '0px' }}
                        // value="20"
                        control={<Radio />}
                        label="All of the Tags"
                        onChange={handleAllOfTag}
                        checked={isAllOfTag}
                      />
                    </>
                  }
                </Stack>

                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <FormControl fullWidth>

                    <Autocomplete
                      open={state?.openEventTypeField}
                      onClose={handleCloseFields}
                      onOpen={handleOpenEventTypeField}
                      value={
                        reportsScoreLogEventType ? ([{
                          eventType: '',
                          eventTypeEventType: 'All',
                          scorecard: ''
                        }].concat(reportsScoreLogEventType))?.find((options) => options?.eventType === values?.eventType)
                          : values?.eventField ?? null
                      }
                      options={reportsScoreLogEventType ? ([{
                        eventType: '',
                        eventTypeEventType: 'All',
                        scorecard: ''
                      }].concat(reportsScoreLogEventType)) : [values?.eventField]}
                      getOptionLabel={(option) =>
                        option?.eventTypeEventType
                          ? `${option.eventTypeEventType} ${option.scorecard ? `(${option.scorecard})` : ''}`
                          : ''
                      }
                      renderOption={renderEventOptions}

                      onChange={(e, newVal) => handleEventTypeChange(e, newVal)}
                      isOptionEqualToValue={(option, value) => {
                        let equalOptions = false
                        if (option?.eventType === '' || option?.eventType) {
                          equalOptions = option?.eventType === value?.eventType
                        } else {
                          equalOptions = filterFieldsData?.eventField?.eventType === value?.eventType
                        }
                        return equalOptions
                      }}
                      ListboxProps={{
                        style: {
                          bottom: 0,
                          overflowY: 'auto'
                        }
                      }}
                      renderInput={(params) => <TextField {...params} label="Event Type"

                        variant="outlined"
                      />
                      }

                    />
                  </FormControl>
                  <FormControl fullWidth>

                    <Autocomplete
                      open={state?.openEventSubTypeField}
                      onClose={handleCloseFields}
                      onOpen={handleOpenEventSubTypeField}
                      value={
                        reportsScoreLogEventSubType ? ([{
                          eventSubType: '',
                          subType: 'All',
                          scorecard: ''
                        }].concat(reportsScoreLogEventSubType))?.find((options) => options?.eventSubType === values?.eventTypeEventSubType)
                          : values?.eventSubField
                      }
                      options={reportsScoreLogEventSubType ? ([{
                        eventSubType: '',
                        subType: 'All',
                        scorecard: ''
                      }].concat(reportsScoreLogEventSubType)) : [values?.eventSubField]}
                      getOptionLabel={(option) =>
                        option?.subType || option?.scorecard
                          ? `${option.subType} ${option.scorecard ? `(${option.scorecard})` : ''}`
                          : ''
                      }
                      renderOption={renderEventSubOptions}

                      onChange={(e, newVal) => handleSubTypeChange(e, newVal)}
                      // isOptionEqualToValue={(option, value) => option?.eventSubType === value?.eventSubType}
                      isOptionEqualToValue={(option, value) => {
                        let equalOptions = false
                        if (option?.eventSubType === "" || option?.eventSubType) {
                          equalOptions = option?.eventSubType === value?.eventSubType
                        } else {
                          equalOptions = filterFieldsData?.eventSubField?.eventSubType === value?.eventSubType
                        }
                        // console.log('option---', option, 'value', value, equalOptions, filterFieldsData)
                        return equalOptions
                      }}
                      ListboxProps={{
                        style: {
                          bottom: 0,
                          overflowY: 'auto'
                        }
                      }}
                      renderInput={(params) => <TextField {...params} label="Event Sub Type"

                        variant="outlined"
                      />
                      }
                    />
                  </FormControl>
                </Stack>
                {(subModLabel === 1.5 || subModLabel === 1.4 || subModLabel === 1.6 ||
                  subModLabel === 1.7 || subModLabel === 1.8) &&
                  <FormControl sx={{ width: "100%" }}>

                    <Autocomplete
                      fullWidth
                      open={state?.openStaffField}
                      onOpen={handleOpenStaffFields}
                      onClose={handleCloseFields}
                      // value={(() => {
                      //   if (reportsScoreLogEmployee) {
                      //     return reportsScoreLogEmployee?.find((option) => option?.staff === values?.staff)
                      //   }

                      //   // if not API loaded and not with "All" value staff fields
                      //   if (values?.staffFieldWithAll?.staffUserFirstName !== 'All') {
                      //     return values?.staffFieldWithAll
                      //   }

                      //   return ''
                      // })()}
                      value={(() => {
                        if (reportsScoreLogEmployee) {
                          const found = reportsScoreLogEmployee.find((option) => option?.staff === values?.staff);
                          if (found) return found;
                        }

                        // If not found in API or API not loaded, check fallback
                        if (
                          values?.staffFieldWithAll &&
                          Object.keys(values.staffFieldWithAll).length > 0 &&
                          values?.staffFieldWithAll?.staffUserFirstName !== 'All'
                        ) {
                          return values.staffFieldWithAll;
                        }

                        return null;
                      })()}
                      options={(() => {
                        if (reportsScoreLogEmployee) return reportsScoreLogEmployee ?? []

                        // if not API loaded and not with "All" value staff fields
                        if (values?.staffFieldWithAll?.staffUserFirstName !== 'All') {
                          return [values?.staffFieldWithAll]
                        }
                        return []
                      })()}

                      getOptionLabel={(option) =>
                        option?.staffUserFirstName || option?.staffUserLastName
                          ? `${option.staffUserFirstName} ${option.staffUserLastName}`
                          : ''
                      }
                      renderOption={renderStaffOptions}
                      isOptionEqualToValue={(option, value) => option?.staff === value?.staff}
                      onChange={(e, newVal) => handleStaffChange(e, newVal)}
                      ListboxProps={{
                        style: {
                          bottom: 0,
                          overflowY: 'auto'
                        }
                      }}
                      renderInput={(params) =>
                        <TextField {...params} label="Employee"

                          variant="outlined"
                          error={Boolean(touched.staff && errors.staff)}
                          helperText={touched.staff && errors.staff}
                          required
                        />}

                    />
                  </FormControl>
                }
                {
                  (advanceFilters && (subModLabel !== 1.11)) && <>
                    <Stack direction={{ xs: 'column', sm: 'column' }} spacing={2}>
                      {((subModLabel !== 1.5) && (subModLabel !== 1.8) && (subModLabel !== 1.7) &&
                        (subModLabel !== 5.11) && (subModLabel !== 5.12) && (subModLabel !== 1.4) &&
                        (subModLabel !== 1.6)) && (subModLabel !== 1.9) &&
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                          <FormControl fullWidth>
                            <Autocomplete
                              open={state?.openSupervisorField}
                              onClose={handleCloseFields}
                              onOpen={handleOpenSupervisorField}
                              // value={values.supervisor}
                              value={
                                reportsScoreLogSupervisor ?
                                  ([{
                                    supervisorUserFirstName: 'All',
                                    supervisorUserLastName: '',
                                    supervisor: ''
                                  }].concat(reportsScoreLogSupervisor))?.find((option) => option?.supervisor === values?.supervisor)
                                  :
                                  values?.supervisorField ?? null
                              }
                              options={
                                (() => {
                                  if (reportsScoreLogSupervisor) return [{ supervisorUserFirstName: 'All', supervisorUserLastName: '', supervisor: '' }, ...reportsScoreLogSupervisor];

                                  // If API not call
                                  if (values?.supervisorField) return [values.supervisorField];

                                  return [{}];
                                })()
                              }
                              getOptionLabel={(option) => `${option.supervisorUserFirstName} ${option.supervisorUserLastName}` || ""}
                              renderOption={renderSupervisorOptions}

                              onChange={(e, newVal) => handleSupervisorChange(e, newVal)}
                              isOptionEqualToValue={(option, value) => option?.supervisor === value?.supervisor}
                              ListboxProps={{
                                style: {
                                  bottom: 0,
                                  overflowY: 'auto'
                                }
                              }}
                              renderInput={(params) => <TextField {...params} label="Supervisor"

                                variant="outlined"
                              />
                              }

                            />
                          </FormControl>
                          {(advanceFilters && (subModLabel === 1.3 || subModLabel === 1.31 || subModLabel === '1.10')) &&
                            <FormControl fullWidth>

                              <Autocomplete
                                fullWidth
                                open={state?.openStaffField}
                                onOpen={handleOpenStaffFields}
                                onClose={handleCloseFields}
                                value={reportsScoreLogEmployee ?
                                  ((subModLabel === 1.10 || subModLabel === 1.3) ?
                                    [{
                                      staffUserFirstName: 'All', staffUserLastName: '', staff: ''
                                    }].concat(reportsScoreLogEmployee) :
                                    reportsScoreLogEmployee)?.find((option) => option?.staff === values?.staff) :
                                  values?.staffFieldWithAll ?? null
                                }
                                options={(() => {
                                  if (reportsScoreLogEmployee) {
                                    if (subModLabel === 1.10 || subModLabel === 1.3) {
                                      return [{
                                        staffUserFirstName: 'All', staffUserLastName: '', staff: ''
                                      }, ...reportsScoreLogEmployee];

                                    }

                                    return reportsScoreLogEmployee
                                  }

                                  // if not API loaded 
                                  if (values?.staffFieldWithAll) {
                                    return [values?.staffFieldWithAll]
                                  }

                                  return []
                                })()}
                                // getOptionLabel={(option) => option?.name || ""}
                                getOptionLabel={(option) => `${option.staffUserFirstName} ${option.staffUserLastName}` || ""}
                                // getOptionLabel={(option) =>
                                //   option?.staffUserFirstName || option?.staffUserLastName
                                //     ? `${option.staffUserFirstName} ${option.staffUserLastName}`
                                //     : ''
                                // }
                                renderOption={renderStaffOptions}
                                isOptionEqualToValue={(option, value) => option?.staff === value?.staff}
                                onChange={(e, newVal) => handleStaffWithAllChange(e, newVal)}
                                ListboxProps={{
                                  style: {
                                    bottom: 0,
                                    overflowY: 'auto'
                                  }
                                }}
                                renderInput={(params) =>
                                  <TextField {...params} label="Employee"
                                    variant="outlined"
                                  />}

                              />
                            </FormControl>
                          }
                        </Stack>}

                      {advanceFilters &&
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                          {
                            (subModLabel === 1.3 || subModLabel === 1.31 ||
                              subModLabel === '1.10' || subModLabel === 1.6) &&
                            <FormControl fullWidth>
                              <Autocomplete
                                open={state?.openSectionField}
                                onClose={handleCloseFields}
                                onOpen={handleOpenSectionField}
                                value={
                                  scorecardSection ? ([{
                                    id: '',
                                    name: 'All',
                                    scoreCard: '',
                                    type: ''
                                  }].concat(scorecardSection))?.find((options) => options?.id === values?.section)
                                    : values?.sectionField ?? null
                                }
                                options={scorecardSection ? ([{
                                  id: '',
                                  name: 'All',
                                  scoreCard: '',
                                  type: ''
                                }].concat(scorecardSection)) : [values?.sectionField]}
                                getOptionLabel={(option) =>
                                  option?.name
                                }
                                renderOption={renderSectionOptions}

                                onChange={(e, newVal) => handleSectionField(e, newVal)}
                                isOptionEqualToValue={(option, value) => {
                                  let equalOptions = false
                                  if (option?.id) {
                                    equalOptions = option?.id === value?.id
                                  } else {
                                    equalOptions = filterFieldsData?.sectionField?.id === value?.id
                                  }
                                  return equalOptions
                                }}
                                ListboxProps={{
                                  style: {
                                    bottom: 0,
                                    overflowY: 'auto'
                                  }
                                }}
                                renderInput={(params) => <TextField {...params} label="Sections"

                                  variant="outlined"
                                />
                                }

                              />
                            </FormControl>
                          }
                          {
                            (subModLabel === 1.3 || subModLabel === 1.31 ||
                              subModLabel === '1.10') && <FormControl fullWidth>
                              <Autocomplete
                                open={state?.openQuestionField}
                                onClose={handleCloseFields}
                                onOpen={handleOpenQuestionField}
                                value={
                                  questionsAnswerByStaff ? ([{
                                    id: '',
                                    question: 'All',
                                  }].concat(questionsAnswerByStaff))?.find((options) => options?.id === values?.question)
                                    : values?.questionField ?? null
                                }
                                options={questionsAnswerByStaff ? ([{
                                  id: '',
                                  question: 'All',
                                }].concat(questionsAnswerByStaff)) : [values?.questionField]}
                                getOptionLabel={(option) =>
                                  option?.question
                                }
                                renderOption={renderQuestionOptions}

                                onChange={(e, newVal) => handleQuestionField(e, newVal)}
                                isOptionEqualToValue={(option, value) => {
                                  let equalOptions = false
                                  if (option?.id) {
                                    equalOptions = option?.id === value?.id
                                  } else {
                                    equalOptions = filterFieldsData?.questionField?.id === value?.id
                                  }
                                  return equalOptions
                                }}
                                ListboxProps={{
                                  style: {
                                    bottom: 0,
                                    overflowY: 'auto'
                                  }
                                }}
                                renderInput={(params) => <TextField {...params} label="Questions"

                                  variant="outlined"
                                />
                                }

                              />
                            </FormControl>
                          }

                        </ Stack>
                      }
                      {subModLabel !== '1.10' && <FormControl fullWidth>

                        <TextField
                          fullWidth
                          type='number'
                          label="Highlight Below"
                          value={values.highlightValue}
                          {...getFieldProps('highlightValue')}
                          error={Boolean(touched.highlightValue && errors.highlightValue)}
                          helperText={touched.highlightValue && errors.highlightValue}
                        />
                      </FormControl>}

                      {((advanceFilters && (subModLabel === 1.2 || subModLabel === 1.5 ||
                        subModLabel === 1.3 || subModLabel === 1.31 || subModLabel === 1.7 ||
                        subModLabel === 1.8 || subModLabel === 1.6))) &&

                        <FormControl fullWidth>
                          <InputLabel shrink id="formula-label">Formula</InputLabel>
                          <Select
                            labelId="formula-label"
                            id="formula-select-small"
                            displayEmpty
                            // value={values.formula}
                            input={<OutlinedInput notched label="Formula" />}
                            {...getFieldProps('formula')}
                          >
                            {(subModLabel === 1.2 || subModLabel === 1.3 ||
                              subModLabel === 1.31 || subModLabel === 1.6 || subModLabel === 1.7 ||
                              subModLabel === 1.8 || subModLabel === 1.5) &&
                              formulaType?.map((item) => (
                                <MenuItem key={item.id} id={item.id} value={item?.id}>
                                  {item.type}
                                </MenuItem>
                              ))}
                          </Select>
                        </FormControl>}
                    </Stack>

                  </>
                }
                {advanceFilters && subModLabel === 1.6 && (
                  <FormControlLabel
                    label="Numeric Values"
                    control={
                      <Checkbox checked={values.numericValues}
                        {...getFieldProps('numericValues')} size="small" />
                    }
                  />
                )}
                {(advanceFilters && subModLabel === 1.11) && <FormControl sx={{ width: "50%" }}>
                  <Autocomplete
                    open={state?.openEvalField}
                    onClose={handleCloseFields}
                    onOpen={handleOpenEvalField}
                    value={
                      reportsScoreLogEvaluator ? ([{
                        evaluator: '',
                        evaluatorFirstName: 'All',
                        evaluatorLastName: ''
                      }].concat(reportsScoreLogEvaluator))?.find((options) => options?.evaluator === values?.evaluator)
                        : values?.evaluatorField ?? null
                    }
                    options={reportsScoreLogEvaluator ? ([{
                      evaluator: '',
                      evaluatorFirstName: 'All',
                      evaluatorLastName: ''
                    }].concat(reportsScoreLogEvaluator)) : [values?.evaluatorField]}
                    getOptionLabel={(option) =>
                      (option?.evaluatorFirstName || option.evaluatorLastName)
                        ? `${option.evaluatorFirstName} ${option.evaluatorLastName}`
                        : ''
                    }
                    renderOption={renderEvalOptions}

                    onChange={(e, newVal) => handleEvalChange(e, newVal)}
                    isOptionEqualToValue={(option, value) => {

                      let equalOptions = false
                      if (option?.evaluator) {
                        equalOptions = option?.evaluator === value?.evaluator
                      } else {
                        equalOptions = filterFieldsData?.evaluatorField?.evaluator === value?.evaluator
                      }
                      return equalOptions
                    }}
                    ListboxProps={{
                      style: {
                        bottom: 0,
                        overflowY: 'auto'
                      }
                    }}
                    renderInput={(params) => <TextField {...params} label="Evaluators"

                      variant="outlined"
                    />
                    }

                  />
                </FormControl>
                }
                {
                  (advanceFilters && subModLabel === 1.2) && <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                    <FormControl fullWidth>
                      <TextField
                        name='Reference'
                        id="outlined-error"
                        label="Reference"
                        variant="outlined"
                        {...getFieldProps('reference')}
                      />
                    </FormControl>

                  </Stack>
                }


              </Stack>
            </DialogContent>

            <DialogActions>
              <Button onClick={() => { handleClose() }} color="inherit">
                Cancel
              </Button>
              <Button disabled={circular} type="submit" variant="contained"
              // loading={isSubmitting}
              >
                Apply
                {circular && <CircularProgress size={14} sx={{ ml: 1 }} />}
              </Button>
            </DialogActions>
          </Form>
        </FormikProvider>
      </Dialog>
    </div>
  );
}